// Extended mock data for POC demonstration

export const extendedModels = [
  {
    id: 'MDL-RET-001',
    code: 'RETAIL_EWS',
    name: 'Mô hình cảnh báo sớm Retail',
    description: 'Mô hình đánh giá rủi ro cho khách hàng bán lẻ',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2025-12-01',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-002', weight: 0.25, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 4, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.99, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH002', 'KH004', 'KH005', 'KH006'],
    assignedCustomerGroups: ['RETAIL', 'HIGH-RISK']
  },
  {
    id: 'MDL-CORP-001',
    code: 'CORP_EWS',
    name: 'Mô hình cảnh báo Doanh nghiệp',
    description: 'Đánh giá rủi ro tín dụng doanh nghiệp lớn',
    targetObject: 'Khách hàng doanh nghiệp',
    status: 'active',
    createdDate: '2025-11-15',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-003', weight: 0.3, frequency: 'Hàng quý' },
      { id: 'IND-FIN-004', weight: 0.3, frequency: 'Hàng quý' },
      { id: 'IND-PAY-001', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.2, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.5, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.49, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH001', 'KH003', 'KH007'],
    assignedCustomerGroups: ['CORP', 'SME']
  },
  {
    id: 'MDL-SME-001',
    code: 'SME_EWS',
    name: 'Mô hình SME Standard',
    description: 'Dành cho doanh nghiệp vừa và nhỏ',
    targetObject: 'Khách hàng doanh nghiệp',
    status: 'active',
    createdDate: '2025-10-20',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-002', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-001', weight: 0.2, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.8, label: 'Rủi ro cao' },
      medium: { min: 2.2, max: 3.79, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.19, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH008', 'KH009'],
    assignedCustomerGroups: ['SME']
  },
  {
    id: 'MDL-VIP-001',
    code: 'VIP_PREMIUM',
    name: 'Mô hình VIP Premium',
    description: 'Đánh giá chuyên biệt cho khách hàng VIP',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2025-12-10',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.2, frequency: 'Hàng tuần' },
      { id: 'IND-PAY-001', weight: 0.2, frequency: 'Hàng tuần' },
      { id: 'IND-BEH-001', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.3, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.5, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.49, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH010', 'KH011'],
    assignedCustomerGroups: ['VIP']
  },
  {
    id: 'MDL-NPL-001',
    code: 'NPL_MONITOR',
    name: 'Mô hình giám sát NPL',
    description: 'Theo dõi và dự báo nợ xấu',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-01-05',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.35, frequency: 'Hàng tuần' },
      { id: 'IND-PAY-001', weight: 0.35, frequency: 'Hàng tuần' },
      { id: 'IND-FIN-002', weight: 0.3, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 4.2, label: 'Rủi ro cao' },
      medium: { min: 2.5, max: 4.19, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.49, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH012', 'KH013'],
    assignedCustomerGroups: ['NPL', 'HIGH-RISK']
  },
  {
    id: 'MDL-RET-002',
    code: 'RETAIL_BASIC',
    name: 'Mô hình Retail Basic',
    description: 'Phiên bản đơn giản cho khách hàng cá nhân mới',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-02-01',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.5, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.5, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.5, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.49, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH014', 'KH015', 'KH016'],
    assignedCustomerGroups: ['RETAIL', 'STARTUP']
  },
  {
    id: 'MDL-CONS-001',
    code: 'CONSUMER_LOAN',
    name: 'Mô hình cho vay tiêu dùng',
    description: 'Đánh giá rủi ro vay tiêu dùng không bảo đảm',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-02-15',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-002', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-001', weight: 0.15, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 4, label: 'Rủi ro cao' },
      medium: { min: 2.3, max: 3.99, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.29, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH017', 'KH018'],
    assignedCustomerGroups: ['RETAIL']
  },
  {
    id: 'MDL-AUTO-001',
    code: 'AUTO_LOAN',
    name: 'Mô hình cho vay ô tô',
    description: 'Chuyên biệt cho khoản vay mua xe',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-03-01',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-002', weight: 0.4, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.35, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.25, frequency: 'Hàng quý' }
    ],
    thresholds: {
      high: { min: 3.8, label: 'Rủi ro cao' },
      medium: { min: 2.2, max: 3.79, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.19, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH019'],
    assignedCustomerGroups: ['RETAIL']
  },
  {
    id: 'MDL-HOME-001',
    code: 'HOME_LOAN',
    name: 'Mô hình cho vay nhà',
    description: 'Dành cho khoản vay mua/xây nhà ở',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-03-10',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-002', weight: 0.35, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.30, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.20, frequency: 'Hàng quý' },
      { id: 'IND-FIN-003', weight: 0.15, frequency: 'Hàng quý' }
    ],
    thresholds: {
      high: { min: 3.5, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.49, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH020'],
    assignedCustomerGroups: ['RETAIL']
  },
  {
    id: 'MDL-TEST-001',
    code: 'TEST_MODEL',
    name: 'Mô hình thử nghiệm AI',
    description: 'Mô hình đang trong giai đoạn thử nghiệm',
    targetObject: 'Khách hàng cá nhân',
    status: 'draft',
    createdDate: '2026-04-01',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.25, frequency: 'Hàng ngày' },
      { id: 'IND-PAY-001', weight: 0.25, frequency: 'Hàng ngày' },
      { id: 'IND-BEH-001', weight: 0.25, frequency: 'Hàng tuần' },
      { id: 'IND-BEH-002', weight: 0.25, frequency: 'Hàng tuần' }
    ],
    thresholds: {
      high: { min: 4, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.99, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: [],
    assignedCustomerGroups: []
  },
  {
    id: 'MDL-TRADE-001',
    code: 'TRADE_FIN',
    name: 'Mô hình tài trợ xuất nhập khẩu',
    description: 'Đánh giá rủi ro tài trợ thương mại',
    targetObject: 'Khách hàng doanh nghiệp',
    status: 'active',
    createdDate: '2026-01-20',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-003', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-004', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.2, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.7, label: 'Rủi ro cao' },
      medium: { min: 2.2, max: 3.69, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.19, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH007'],
    assignedCustomerGroups: ['CORP']
  },
  {
    id: 'MDL-MICRO-001',
    code: 'MICRO_FIN',
    name: 'Mô hình cho vay vi mô',
    description: 'Dành cho khách hàng thu nhập thấp',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-02-28',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-002', weight: 0.35, frequency: 'Hàng tuần' },
      { id: 'IND-PAY-001', weight: 0.35, frequency: 'Hàng tuần' },
      { id: 'IND-BEH-001', weight: 0.3, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.8, label: 'Rủi ro cao' },
      medium: { min: 2.3, max: 3.79, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.29, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: [],
    assignedCustomerGroups: ['RETAIL']
  },
  {
    id: 'MDL-AGRI-001',
    code: 'AGRI_LOAN',
    name: 'Mô hình cho vay nông nghiệp',
    description: 'Đặc thù cho lĩnh vực nông nghiệp',
    targetObject: 'Khách hàng doanh nghiệp',
    status: 'active',
    createdDate: '2026-03-15',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-003', weight: 0.3, frequency: 'Hàng quý' },
      { id: 'IND-FIN-004', weight: 0.25, frequency: 'Hàng quý' },
      { id: 'IND-PAY-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.2, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.6, label: 'Rủi ro cao' },
      medium: { min: 2.1, max: 3.59, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.09, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH001'],
    assignedCustomerGroups: ['SME']
  },
  {
    id: 'MDL-RETAIL-003',
    code: 'RETAIL_PRO',
    name: 'Mô hình Retail Professional',
    description: 'Phiên bản nâng cao với nhiều chỉ tiêu',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-03-25',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-002', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.2, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 4, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.99, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH002', 'KH004', 'KH005'],
    assignedCustomerGroups: ['RETAIL']
  },
  {
    id: 'MDL-CARD-001',
    code: 'CREDIT_CARD',
    name: 'Mô hình thẻ tín dụng',
    description: 'Đánh giá rủi ro phát hành thẻ tín dụng',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-04-05',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-BEH-001', weight: 0.35, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-002', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-001', weight: 0.1, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.5, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.49, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH010', 'KH011', 'KH014'],
    assignedCustomerGroups: ['VIP', 'RETAIL']
  },
  {
    id: 'MDL-OVERDRAFT-001',
    code: 'OVERDRAFT',
    name: 'Mô hình thấu chi',
    description: 'Đánh giá cấp hạn mức thấu chi',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-04-15',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-002', weight: 0.4, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.35, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.25, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.7, label: 'Rủi ro cao' },
      medium: { min: 2.2, max: 3.69, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.19, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: [],
    assignedCustomerGroups: ['RETAIL', 'VIP']
  },
  {
    id: 'MDL-CORP-002',
    code: 'CORP_ADVANCED',
    name: 'Mô hình Doanh nghiệp nâng cao',
    description: 'Tích hợp Machine Learning',
    targetObject: 'Khách hàng doanh nghiệp',
    status: 'active',
    createdDate: '2026-04-20',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-003', weight: 0.25, frequency: 'Hàng quý' },
      { id: 'IND-FIN-004', weight: 0.25, frequency: 'Hàng quý' },
      { id: 'IND-PAY-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.25, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.8, label: 'Rủi ro cao' },
      medium: { min: 2.3, max: 3.79, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.29, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH003', 'KH007', 'KH008'],
    assignedCustomerGroups: ['CORP']
  },
  {
    id: 'MDL-STARTUP-001',
    code: 'STARTUP_EWS',
    name: 'Mô hình Startup',
    description: 'Dành cho doanh nghiệp khởi nghiệp',
    targetObject: 'Khách hàng doanh nghiệp',
    status: 'active',
    createdDate: '2026-05-01',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-003', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-002', weight: 0.15, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 4, label: 'Rủi ro cao' },
      medium: { min: 2.5, max: 3.99, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.49, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH009'],
    assignedCustomerGroups: ['STARTUP', 'SME']
  },
  {
    id: 'MDL-RECOVERY-001',
    code: 'DEBT_RECOVERY',
    name: 'Mô hình thu hồi nợ',
    description: 'Ưu tiên thu hồi nợ khó',
    targetObject: 'Khách hàng cá nhân',
    status: 'inactive',
    createdDate: '2026-05-10',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.4, frequency: 'Hàng tuần' },
      { id: 'IND-PAY-001', weight: 0.4, frequency: 'Hàng tuần' },
      { id: 'IND-BEH-001', weight: 0.2, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 4.5, label: 'Rủi ro cao' },
      medium: { min: 3, max: 4.49, label: 'Rủi ro trung bình' },
      low: { min: 1.5, max: 2.99, label: 'Rủi ro thấp' },
      none: { max: 1.49, label: 'Không có rủi ro' }
    },
    assignedCustomers: [],
    assignedCustomerGroups: ['NPL']
  },
  {
    id: 'MDL-HYBRID-001',
    code: 'HYBRID_MODEL',
    name: 'Mô hình Hybrid đa đối tượng',
    description: 'Áp dụng cho cả cá nhân và doanh nghiệp',
    targetObject: 'Các ĐCTC',
    status: 'draft',
    createdDate: '2026-05-15',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-FIN-003', weight: 0.25, frequency: 'Hàng quý' },
      { id: 'IND-PAY-001', weight: 0.25, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.25, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.8, label: 'Rủi ro cao' },
      medium: { min: 2.2, max: 3.79, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.19, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: [],
    assignedCustomerGroups: []
  },
  {
    id: 'MDL-EXPORT-001',
    code: 'EXPORT_FIN',
    name: 'Mô hình tài trợ xuất khẩu',
    description: 'Đánh giá rủi ro cho doanh nghiệp xuất khẩu',
    targetObject: 'Khách hàng doanh nghiệp',
    status: 'active',
    createdDate: '2026-05-20',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-003', weight: 0.25, frequency: 'Hàng quý' },
      { id: 'IND-FIN-004', weight: 0.25, frequency: 'Hàng quý' },
      { id: 'IND-PAY-001', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-EXT-001', weight: 0.3, frequency: 'Hàng quý' }
    ],
    thresholds: {
      high: { min: 4, label: 'Rủi ro cao' },
      medium: { min: 2.5, max: 3.99, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.49, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH021'],
    assignedCustomerGroups: ['CORP']
  },
  {
    id: 'MDL-WEALTH-001',
    code: 'WEALTH_MGMT',
    name: 'Mô hình Quản lý tài sản',
    description: 'Dành cho khách hàng có tài sản cao',
    targetObject: 'Khách hàng cá nhân',
    status: 'active',
    createdDate: '2026-05-22',
    calculationMethod: 'weighted_sum',
    indicators: [
      { id: 'IND-FIN-002', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-001', weight: 0.3, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-002', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.2, frequency: 'Hàng tháng' }
    ],
    thresholds: {
      high: { min: 3.5, label: 'Rủi ro cao' },
      medium: { min: 2, max: 3.49, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 1.99, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: ['KH010', 'KH011', 'KH022'],
    assignedCustomerGroups: ['VIP']
  },
  {
    id: 'MDL-FINTECH-001',
    code: 'FINTECH_SCORE',
    name: 'Mô hình Fintech AI',
    description: 'Sử dụng machine learning cho chấm điểm tín dụng',
    targetObject: 'Các ĐCTC',
    status: 'active',
    createdDate: '2026-05-25',
    calculationMethod: 'ml_algorithm',
    indicators: [
      { id: 'IND-FIN-001', weight: 0.2, frequency: 'Hàng ngày' },
      { id: 'IND-FIN-002', weight: 0.2, frequency: 'Hàng tháng' },
      { id: 'IND-PAY-001', weight: 0.2, frequency: 'Hàng ngày' },
      { id: 'IND-PAY-002', weight: 0.15, frequency: 'Hàng ngày' },
      { id: 'IND-BEH-001', weight: 0.15, frequency: 'Hàng tháng' },
      { id: 'IND-BEH-002', weight: 0.1, frequency: 'Hàng tuần' }
    ],
    thresholds: {
      high: { min: 4.2, label: 'Rủi ro cao' },
      medium: { min: 2.5, max: 4.19, label: 'Rủi ro trung bình' },
      low: { min: 1, max: 2.49, label: 'Rủi ro thấp' },
      none: { max: 0.99, label: 'Không có rủi ro' }
    },
    assignedCustomers: [],
    assignedCustomerGroups: []
  }
];

export const extendedCustomers = [
  {
    id: 'KH001',
    code: 'C00055',
    name: 'Đinh Hữu Yến',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 94 2201',
    email: 'inhhuyn@email.com',
    idNumber: '68371809151',
    creditLimit: 4627000000,
    currentBalance: 3886680000,
    totalDebt: 4441920000,
    riskLevel: 'Thấp',
    riskScore: 9,
    createdDate: '19/01/2026 13:32',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH002',
    code: 'C00056',
    name: 'Hoàng Thanh Cường',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 93 2209',
    email: 'hongthanhcng@email.com',
    idNumber: '56689340849',
    creditLimit: 2680000000,
    currentBalance: 2278000000,
    totalDebt: 2546000000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '08/04/2026 16:16',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH003',
    code: 'C00057',
    name: 'Công ty Cổ phần Công nghệ phần mềm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Thương mại',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 95 3495',
    email: 'cngtycphncngnghphnmm@email.com',
    idNumber: '30514069897',
    creditLimit: 1290000000,
    currentBalance: 1251300000,
    totalDebt: 1277100000,
    riskLevel: 'Trung bình',
    riskScore: 16,
    createdDate: '09/01/2026 12:52',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH004',
    code: 'C00058',
    name: 'Tô Anh Hà',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 96 3868',
    email: 'tanhh@email.com',
    idNumber: '24937531240',
    creditLimit: 3964000000,
    currentBalance: 3290120000,
    totalDebt: 3488320000,
    riskLevel: 'Cao',
    riskScore: 21,
    createdDate: '12/01/2026 16:53',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH005',
    code: 'C00059',
    name: 'Nguyễn Thu An',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 98 7068',
    email: 'nguynthuan@email.com',
    idNumber: '50747755227',
    creditLimit: 2253000000,
    currentBalance: 1982640000,
    totalDebt: 1982640000,
    riskLevel: 'Thấp',
    riskScore: 3,
    createdDate: '11/03/2026 17:10',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH006',
    code: 'C00060',
    name: 'Công ty Nhà nước Du lịch và khách sạn',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Nông nghiệp',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 95 2377',
    email: 'cngtynhncdulchvkhchsn@email.com',
    idNumber: '81622131158',
    creditLimit: 1890000000,
    currentBalance: 1512000000,
    totalDebt: 1644300000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '08/05/2026 08:59',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH007',
    code: 'C00061',
    name: 'Đinh Phương Dũng',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 93 5239',
    email: 'inhphngdng@email.com',
    idNumber: '47477748112',
    creditLimit: 679000000,
    currentBalance: 617890000,
    totalDebt: 665420000,
    riskLevel: 'Trung bình',
    riskScore: 17,
    createdDate: '14/12/2025 14:19',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH008',
    code: 'C00062',
    name: 'Đinh Thanh Vân',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 91 4800',
    email: 'inhthanhvn@email.com',
    idNumber: '53944714075',
    creditLimit: 2125000000,
    currentBalance: 2040000000,
    totalDebt: 2018750000,
    riskLevel: 'Thấp',
    riskScore: 4,
    createdDate: '03/01/2026 08:20',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH009',
    code: 'C00063',
    name: 'Công ty Hợp danh Xuất nhập khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Thương mại',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 92 4071',
    email: 'cngtyhpdanhxutnhpkhu@email.com',
    idNumber: '75473351258',
    creditLimit: 2018000000,
    currentBalance: 1796020000,
    totalDebt: 1997820000,
    riskLevel: 'Cao',
    riskScore: 28,
    createdDate: '08/05/2026 08:56',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH010',
    code: 'C00064',
    name: 'Huỳnh Văn Giang',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 93 7988',
    email: 'hunhvngiang@email.com',
    idNumber: '74474824147',
    creditLimit: 3485000000,
    currentBalance: 2822850000,
    totalDebt: 3241050000,
    riskLevel: 'Trung bình',
    riskScore: 19,
    createdDate: '06/02/2026 08:59',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH011',
    code: 'C00065',
    name: 'Ngô Minh Hiếu',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 96 5855',
    email: 'ngminhhiu@email.com',
    idNumber: '30314537310',
    creditLimit: 3695000000,
    currentBalance: 3251600000,
    totalDebt: 3288550000,
    riskLevel: 'Thấp',
    riskScore: 5,
    createdDate: '31/03/2026 16:46',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH012',
    code: 'C00066',
    name: 'Công ty Nhà nước Phát triển bất động sản',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Thương mại',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 90 5238',
    email: 'cngtynhncphttrinbtngsn@email.com',
    idNumber: '54427982178',
    creditLimit: 4707000000,
    currentBalance: 3953880000,
    totalDebt: 4471650000,
    riskLevel: 'Thấp',
    riskScore: 6,
    createdDate: '10/05/2026 14:36',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH013',
    code: 'C00067',
    name: 'Dương Thanh Nhung',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 90 6182',
    email: 'dngthanhnhung@email.com',
    idNumber: '10034971786',
    creditLimit: 907000000,
    currentBalance: 780020000,
    totalDebt: 861650000,
    riskLevel: 'Cao',
    riskScore: 25,
    createdDate: '27/03/2026 12:40',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH014',
    code: 'C00068',
    name: 'Phan Văn Xuân',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 97 6556',
    email: 'phanvnxun@email.com',
    idNumber: '23536905148',
    creditLimit: 3588000000,
    currentBalance: 2978040000,
    totalDebt: 3444480000,
    riskLevel: 'Trung bình',
    riskScore: 17,
    createdDate: '24/04/2026 16:03',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH015',
    code: 'C00069',
    name: 'Công ty Nhà nước Chế biến thực phẩm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Nông nghiệp',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 93 3676',
    email: 'cngtynhncchbinthcphm@email.com',
    idNumber: '34147073925',
    creditLimit: 3624000000,
    currentBalance: 3007920000,
    totalDebt: 3442800000,
    riskLevel: 'Cao',
    riskScore: 30,
    createdDate: '10/01/2026 11:47',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH016',
    code: 'C00070',
    name: 'Đỗ Thu Cường',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 96 1478',
    email: 'thucng@email.com',
    idNumber: '36012051889',
    creditLimit: 3984000000,
    currentBalance: 3625440000,
    totalDebt: 3585600000,
    riskLevel: 'Thấp',
    riskScore: 9,
    createdDate: '10/02/2026 11:25',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH017',
    code: 'C00071',
    name: 'Đỗ Thị Vân',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 95 7866',
    email: 'thvn@email.com',
    idNumber: '51241015328',
    creditLimit: 1004000000,
    currentBalance: 803200000,
    totalDebt: 963840000,
    riskLevel: 'Cao',
    riskScore: 29,
    createdDate: '14/02/2026 11:45',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH018',
    code: 'C00072',
    name: 'Công ty Tư nhân Dịch vụ logistics',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Bất động sản',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 91 1676',
    email: 'cngtytnhndchvlogistics@email.com',
    idNumber: '38670340490',
    creditLimit: 2048000000,
    currentBalance: 1740800000,
    totalDebt: 1966080000,
    riskLevel: 'Cao',
    riskScore: 30,
    createdDate: '13/01/2026 13:42',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH019',
    code: 'C00073',
    name: 'Lý Phương Nam',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 99 3244',
    email: 'lphngnam@email.com',
    idNumber: '62248523137',
    creditLimit: 1436000000,
    currentBalance: 1407280000,
    totalDebt: 1364200000,
    riskLevel: 'Trung bình',
    riskScore: 15,
    createdDate: '18/04/2026 12:42',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH020',
    code: 'C00074',
    name: 'Mai Hữu Khoa',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 97 2173',
    email: 'maihukhoa@email.com',
    idNumber: '22727765235',
    creditLimit: 1777000000,
    currentBalance: 1457140000,
    totalDebt: 1652610000,
    riskLevel: 'Cao',
    riskScore: 20,
    createdDate: '02/12/2025 16:50',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH021',
    code: 'C00075',
    name: 'Công ty Tư nhân Công nghệ phần mềm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Năng lượng',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 94 6103',
    email: 'cngtytnhncngnghphnmm@email.com',
    idNumber: '48855204430',
    creditLimit: 972000000,
    currentBalance: 845640000,
    totalDebt: 874800000,
    riskLevel: 'Thấp',
    riskScore: 9,
    createdDate: '09/02/2026 13:51',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH022',
    code: 'C00076',
    name: 'Phan Minh Uyên',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 94 3335',
    email: 'phanminhuyn@email.com',
    idNumber: '16277691319',
    creditLimit: 4948000000,
    currentBalance: 4700600000,
    totalDebt: 4502680000,
    riskLevel: 'Thấp',
    riskScore: 5,
    createdDate: '09/02/2026 15:34',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH023',
    code: 'C00077',
    name: 'Huỳnh Văn Em',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 98 7252',
    email: 'hunhvnem@email.com',
    idNumber: '24914878896',
    creditLimit: 3544000000,
    currentBalance: 3402240000,
    totalDebt: 3295920000,
    riskLevel: 'Trung bình',
    riskScore: 19,
    createdDate: '05/12/2025 13:49',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH024',
    code: 'C00078',
    name: 'Công ty Cổ phần May mặc xuất khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Y tế',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 96 1318',
    email: 'cngtycphnmaymcxutkhu@email.com',
    idNumber: '56601397624',
    creditLimit: 1445000000,
    currentBalance: 1401650000,
    totalDebt: 1314950000,
    riskLevel: 'Cao',
    riskScore: 27,
    createdDate: '22/04/2026 11:18',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH025',
    code: 'C00079',
    name: 'Phan Quốc Linh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 92 7790',
    email: 'phanquclinh@email.com',
    idNumber: '59411290210',
    creditLimit: 203000000,
    currentBalance: 180670000,
    totalDebt: 196910000,
    riskLevel: 'Thấp',
    riskScore: 8,
    createdDate: '01/01/2026 12:18',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH026',
    code: 'C00080',
    name: 'Đặng Phương Phúc',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 94 2753',
    email: 'ngphngphc@email.com',
    idNumber: '64480158700',
    creditLimit: 2642000000,
    currentBalance: 2272120000,
    totalDebt: 2589160000,
    riskLevel: 'Thấp',
    riskScore: 3,
    createdDate: '15/05/2026 13:28',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH027',
    code: 'C00081',
    name: 'Công ty Tư nhân Xuất nhập khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Y tế',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 98 5513',
    email: 'cngtytnhnxutnhpkhu@email.com',
    idNumber: '87131936113',
    creditLimit: 4233000000,
    currentBalance: 3428730000,
    totalDebt: 3852030000,
    riskLevel: 'Trung bình',
    riskScore: 15,
    createdDate: '15/03/2026 17:32',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH028',
    code: 'C00082',
    name: 'Lê Văn Phong',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 99 4152',
    email: 'lvnphong@email.com',
    idNumber: '71099681293',
    creditLimit: 1426000000,
    currentBalance: 1169320000,
    totalDebt: 1340440000,
    riskLevel: 'Cao',
    riskScore: 23,
    createdDate: '19/02/2026 09:22',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH029',
    code: 'C00083',
    name: 'Đặng Đức Khánh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 93 4636',
    email: 'ngckhnh@email.com',
    idNumber: '69475308911',
    creditLimit: 1839000000,
    currentBalance: 1691880000,
    totalDebt: 1655100000,
    riskLevel: 'Trung bình',
    riskScore: 13,
    createdDate: '11/03/2026 08:33',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH030',
    code: 'C00084',
    name: 'Công ty Cổ phần Công nghệ phần mềm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Sản xuất',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 99 4032',
    email: 'cngtycphncngnghphnmm@email.com',
    idNumber: '19706911732',
    creditLimit: 1873000000,
    currentBalance: 1816810000,
    totalDebt: 1666970000,
    riskLevel: 'Thấp',
    riskScore: 6,
    createdDate: '31/03/2026 11:48',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH031',
    code: 'C00085',
    name: 'Nguyễn Hữu Phúc',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 94 7681',
    email: 'nguynhuphc@email.com',
    idNumber: '33089533721',
    creditLimit: 4914000000,
    currentBalance: 4127760000,
    totalDebt: 4766580000,
    riskLevel: 'Cao',
    riskScore: 29,
    createdDate: '04/04/2026 10:58',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH032',
    code: 'C00086',
    name: 'Dương Văn Bình',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 98 4229',
    email: 'dngvnbnh@email.com',
    idNumber: '85208254839',
    creditLimit: 2875000000,
    currentBalance: 2731250000,
    totalDebt: 2817500000,
    riskLevel: 'Thấp',
    riskScore: 4,
    createdDate: '11/02/2026 09:06',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH033',
    code: 'C00087',
    name: 'Công ty Cổ phần Cơ khí chế tạo',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Sản xuất',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 97 6199',
    email: 'cngtycphnckhchto@email.com',
    idNumber: '32379194467',
    creditLimit: 4490000000,
    currentBalance: 3906300000,
    totalDebt: 4310400000,
    riskLevel: 'Trung bình',
    riskScore: 17,
    createdDate: '04/01/2026 17:29',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH034',
    code: 'C00088',
    name: 'Chu Thanh An',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 96 7321',
    email: 'chuthanhan@email.com',
    idNumber: '49457648552',
    creditLimit: 3357000000,
    currentBalance: 2887020000,
    totalDebt: 3054870000,
    riskLevel: 'Cao',
    riskScore: 25,
    createdDate: '17/05/2026 09:00',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH035',
    code: 'C00089',
    name: 'Bùi Hữu Nam',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 99 5301',
    email: 'bihunam@email.com',
    idNumber: '61929755381',
    creditLimit: 1838000000,
    currentBalance: 1543920000,
    totalDebt: 1819620000,
    riskLevel: 'Thấp',
    riskScore: 4,
    createdDate: '21/03/2026 15:12',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH036',
    code: 'C00090',
    name: 'Công ty Cổ phần Tư vấn đầu tư',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Xây dựng',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 91 8843',
    email: 'cngtycphntvnut@email.com',
    idNumber: '60619887659',
    creditLimit: 3290000000,
    currentBalance: 2961000000,
    totalDebt: 2895200000,
    riskLevel: 'Cao',
    riskScore: 25,
    createdDate: '30/12/2025 10:37',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH037',
    code: 'C00091',
    name: 'Đỗ Thị Hà',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 92 8748',
    email: 'thh@email.com',
    idNumber: '28238631526',
    creditLimit: 1009000000,
    currentBalance: 877830000,
    totalDebt: 958550000,
    riskLevel: 'Thấp',
    riskScore: 7,
    createdDate: '05/02/2026 13:13',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH038',
    code: 'C00092',
    name: 'Phan Đức Bình',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 96 5969',
    email: 'phancbnh@email.com',
    idNumber: '44126305895',
    creditLimit: 4201000000,
    currentBalance: 3612860000,
    totalDebt: 3864920000,
    riskLevel: 'Cao',
    riskScore: 26,
    createdDate: '13/02/2026 08:15',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH039',
    code: 'C00093',
    name: 'Công ty Tư nhân Xuất nhập khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Y tế',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 93 9793',
    email: 'cngtytnhnxutnhpkhu@email.com',
    idNumber: '90790456387',
    creditLimit: 472000000,
    currentBalance: 410640000,
    totalDebt: 453120000,
    riskLevel: 'Trung bình',
    riskScore: 12,
    createdDate: '16/12/2025 17:06',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH040',
    code: 'C00094',
    name: 'Đặng Thanh Dũng',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 98 6443',
    email: 'ngthanhdng@email.com',
    idNumber: '18581323292',
    creditLimit: 2436000000,
    currentBalance: 1973160000,
    totalDebt: 2362920000,
    riskLevel: 'Cao',
    riskScore: 23,
    createdDate: '12/04/2026 09:55',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH041',
    code: 'C00095',
    name: 'Phan Thanh Khánh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 90 3796',
    email: 'phanthanhkhnh@email.com',
    idNumber: '99910164500',
    creditLimit: 1327000000,
    currentBalance: 1247380000,
    totalDebt: 1287190000,
    riskLevel: 'Trung bình',
    riskScore: 13,
    createdDate: '01/04/2026 10:10',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH042',
    code: 'C00096',
    name: 'Công ty TNHH Xuất nhập khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Viễn thông',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 98 9833',
    email: 'cngtytnhhxutnhpkhu@email.com',
    idNumber: '38643261716',
    creditLimit: 916000000,
    currentBalance: 806080000,
    totalDebt: 851880000,
    riskLevel: 'Thấp',
    riskScore: 3,
    createdDate: '27/02/2026 16:18',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH043',
    code: 'C00097',
    name: 'Phạm Văn Phong',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 94 7994',
    email: 'phmvnphong@email.com',
    idNumber: '87495997437',
    creditLimit: 4436000000,
    currentBalance: 3637520000,
    totalDebt: 4391640000,
    riskLevel: 'Trung bình',
    riskScore: 19,
    createdDate: '03/02/2026 08:49',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH044',
    code: 'C00098',
    name: 'Đỗ Thanh Khoa',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 92 4647',
    email: 'thanhkhoa@email.com',
    idNumber: '12341507978',
    creditLimit: 927000000,
    currentBalance: 750870000,
    totalDebt: 899190000,
    riskLevel: 'Cao',
    riskScore: 28,
    createdDate: '07/01/2026 12:04',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH045',
    code: 'C00099',
    name: 'Công ty TNHH Thương mại điện tử',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Xây dựng',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 95 4807',
    email: 'cngtytnhhthngmiint@email.com',
    idNumber: '99653363125',
    creditLimit: 4978000000,
    currentBalance: 4828660000,
    totalDebt: 4629540000,
    riskLevel: 'Cao',
    riskScore: 30,
    createdDate: '05/05/2026 13:56',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH046',
    code: 'C00100',
    name: 'Phan Đức Phúc',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 92 4533',
    email: 'phancphc@email.com',
    idNumber: '49152605291',
    creditLimit: 1874000000,
    currentBalance: 1817780000,
    totalDebt: 1742820000,
    riskLevel: 'Cao',
    riskScore: 23,
    createdDate: '21/12/2025 10:20',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH047',
    code: 'C00101',
    name: 'Vũ Văn Quân',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 99 2286',
    email: 'vvnqun@email.com',
    idNumber: '32385222418',
    creditLimit: 4834000000,
    currentBalance: 4398940000,
    totalDebt: 4398940000,
    riskLevel: 'Trung bình',
    riskScore: 12,
    createdDate: '24/12/2025 11:20',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH048',
    code: 'C00102',
    name: 'Công ty Nhà nước Nông nghiệp công nghệ cao',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Nông nghiệp',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 97 9309',
    email: 'cngtynhncnngnghipcngnghcao@email.com',
    idNumber: '77945124083',
    creditLimit: 4902000000,
    currentBalance: 4215720000,
    totalDebt: 4362780000,
    riskLevel: 'Cao',
    riskScore: 25,
    createdDate: '07/04/2026 09:34',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH049',
    code: 'C00103',
    name: 'Tô Thị Yến',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 91 1275',
    email: 'tthyn@email.com',
    idNumber: '13739848627',
    creditLimit: 4946000000,
    currentBalance: 4748160000,
    totalDebt: 4896540000,
    riskLevel: 'Trung bình',
    riskScore: 19,
    createdDate: '29/01/2026 14:49',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH050',
    code: 'C00104',
    name: 'Đặng Hữu Hương',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 91 4244',
    email: 'nghuhng@email.com',
    idNumber: '97646036908',
    creditLimit: 1647000000,
    currentBalance: 1432890000,
    totalDebt: 1432890000,
    riskLevel: 'Thấp',
    riskScore: 4,
    createdDate: '19/02/2026 12:15',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH051',
    code: 'C00105',
    name: 'Công ty Nhà nước Dược phẩm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Nông nghiệp',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 91 7069',
    email: 'cngtynhncdcphm@email.com',
    idNumber: '99454669230',
    creditLimit: 4635000000,
    currentBalance: 4217850000,
    totalDebt: 4542300000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '15/12/2025 08:08',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH052',
    code: 'C00106',
    name: 'Phạm Quốc Oanh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 93 3032',
    email: 'phmqucoanh@email.com',
    idNumber: '66297043451',
    creditLimit: 2987000000,
    currentBalance: 2628560000,
    totalDebt: 2538950000,
    riskLevel: 'Cao',
    riskScore: 25,
    createdDate: '12/12/2025 15:46',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH053',
    code: 'C00107',
    name: 'Đặng Thị Nam',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 94 2909',
    email: 'ngthnam@email.com',
    idNumber: '42693586287',
    creditLimit: 2883000000,
    currentBalance: 2537040000,
    totalDebt: 2796510000,
    riskLevel: 'Thấp',
    riskScore: 8,
    createdDate: '04/12/2025 09:11',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH054',
    code: 'C00108',
    name: 'Công ty Nhà nước Phát triển bất động sản',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Du lịch',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 99 5308',
    email: 'cngtynhncphttrinbtngsn@email.com',
    idNumber: '66258864269',
    creditLimit: 3758000000,
    currentBalance: 3382200000,
    totalDebt: 3720420000,
    riskLevel: 'Thấp',
    riskScore: 2,
    createdDate: '25/01/2026 12:39',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH055',
    code: 'C00109',
    name: 'Lý Phương Linh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 91 5448',
    email: 'lphnglinh@email.com',
    idNumber: '90389567027',
    creditLimit: 242000000,
    currentBalance: 232320000,
    totalDebt: 217800000,
    riskLevel: 'Trung bình',
    riskScore: 13,
    createdDate: '05/12/2025 13:43',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH056',
    code: 'C00110',
    name: 'Hồ Thị Em',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 99 4705',
    email: 'hthem@email.com',
    idNumber: '22348265117',
    creditLimit: 1741000000,
    currentBalance: 1479850000,
    totalDebt: 1706180000,
    riskLevel: 'Trung bình',
    riskScore: 12,
    createdDate: '02/05/2026 08:16',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH057',
    code: 'C00111',
    name: 'Công ty Cổ phần Công nghệ phần mềm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Tài chính',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 93 5813',
    email: 'cngtycphncngnghphnmm@email.com',
    idNumber: '27057915030',
    creditLimit: 3397000000,
    currentBalance: 2819510000,
    totalDebt: 3159210000,
    riskLevel: 'Trung bình',
    riskScore: 14,
    createdDate: '18/03/2026 12:49',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH058',
    code: 'C00112',
    name: 'Đỗ Phương Hiếu',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 91 5371',
    email: 'phnghiu@email.com',
    idNumber: '98094017960',
    creditLimit: 4427000000,
    currentBalance: 4117110000,
    totalDebt: 3940030000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '12/01/2026 08:22',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH059',
    code: 'C00113',
    name: 'Huỳnh Thanh Cường',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 98 4113',
    email: 'hunhthanhcng@email.com',
    idNumber: '70245151143',
    creditLimit: 3444000000,
    currentBalance: 3134040000,
    totalDebt: 3168480000,
    riskLevel: 'Thấp',
    riskScore: 2,
    createdDate: '30/12/2025 09:54',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH060',
    code: 'C00114',
    name: 'Công ty Nhà nước May mặc xuất khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Bất động sản',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 91 9034',
    email: 'cngtynhncmaymcxutkhu@email.com',
    idNumber: '83416342335',
    creditLimit: 4768000000,
    currentBalance: 4291200000,
    totalDebt: 4243520000,
    riskLevel: 'Thấp',
    riskScore: 6,
    createdDate: '07/02/2026 16:09',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH061',
    code: 'C00115',
    name: 'Tô Hữu Khánh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 95 4843',
    email: 'thukhnh@email.com',
    idNumber: '21904725071',
    creditLimit: 2156000000,
    currentBalance: 1832600000,
    totalDebt: 1940400000,
    riskLevel: 'Thấp',
    riskScore: 7,
    createdDate: '30/05/2026 08:13',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH062',
    code: 'C00116',
    name: 'Phan Quốc Phúc',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 92 3005',
    email: 'phanqucphc@email.com',
    idNumber: '39937949817',
    creditLimit: 4728000000,
    currentBalance: 4255200000,
    totalDebt: 4491600000,
    riskLevel: 'Trung bình',
    riskScore: 14,
    createdDate: '14/02/2026 10:15',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH063',
    code: 'C00117',
    name: 'Công ty Nhà nước Công nghệ phần mềm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Nông nghiệp',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 93 1721',
    email: 'cngtynhnccngnghphnmm@email.com',
    idNumber: '97828510785',
    creditLimit: 3900000000,
    currentBalance: 3588000000,
    totalDebt: 3705000000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '27/02/2026 15:11',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH064',
    code: 'C00118',
    name: 'Ngô Thị Sơn',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 94 6825',
    email: 'ngthsn@email.com',
    idNumber: '82438548495',
    creditLimit: 4868000000,
    currentBalance: 4381200000,
    totalDebt: 4478560000,
    riskLevel: 'Trung bình',
    riskScore: 14,
    createdDate: '27/04/2026 09:01',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH065',
    code: 'C00119',
    name: 'Đặng Đức Bình',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 98 2776',
    email: 'ngcbnh@email.com',
    idNumber: '74538974332',
    creditLimit: 499000000,
    currentBalance: 409180000,
    totalDebt: 474050000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '02/04/2026 14:23',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH066',
    code: 'C00120',
    name: 'Công ty Hợp danh Phát triển bất động sản',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Y tế',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 96 8829',
    email: 'cngtyhpdanhphttrinbtngsn@email.com',
    idNumber: '20410140618',
    creditLimit: 2378000000,
    currentBalance: 1949960000,
    totalDebt: 2116420000,
    riskLevel: 'Thấp',
    riskScore: 9,
    createdDate: '10/05/2026 10:03',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH067',
    code: 'C00121',
    name: 'Đặng Anh Mai',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 98 5010',
    email: 'nganhmai@email.com',
    idNumber: '73041880524',
    creditLimit: 1357000000,
    currentBalance: 1194160000,
    totalDebt: 1275580000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '01/01/2026 08:48',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH068',
    code: 'C00122',
    name: 'Bùi Minh Tâm',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 91 6545',
    email: 'biminhtm@email.com',
    idNumber: '87408942369',
    creditLimit: 345000000,
    currentBalance: 279450000,
    totalDebt: 313950000,
    riskLevel: 'Cao',
    riskScore: 27,
    createdDate: '12/01/2026 17:55',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH069',
    code: 'C00123',
    name: 'Công ty Tư nhân Xuất nhập khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Nông nghiệp',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 97 9451',
    email: 'cngtytnhnxutnhpkhu@email.com',
    idNumber: '38623809382',
    creditLimit: 2904000000,
    currentBalance: 2526480000,
    totalDebt: 2787840000,
    riskLevel: 'Thấp',
    riskScore: 2,
    createdDate: '04/04/2026 14:41',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH070',
    code: 'C00124',
    name: 'Ngô Thu Long',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 93 9282',
    email: 'ngthulong@email.com',
    idNumber: '58883229277',
    creditLimit: 3896000000,
    currentBalance: 3155760000,
    totalDebt: 3584320000,
    riskLevel: 'Trung bình',
    riskScore: 13,
    createdDate: '20/05/2026 08:35',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH071',
    code: 'C00125',
    name: 'Huỳnh Anh Tâm',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 99 1858',
    email: 'hunhanhtm@email.com',
    idNumber: '12471976589',
    creditLimit: 1122000000,
    currentBalance: 1043460000,
    totalDebt: 1065900000,
    riskLevel: 'Trung bình',
    riskScore: 16,
    createdDate: '18/05/2026 09:40',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH072',
    code: 'C00126',
    name: 'Công ty Hợp danh Dược phẩm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Vận tải',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 90 7643',
    email: 'cngtyhpdanhdcphm@email.com',
    idNumber: '52709745410',
    creditLimit: 4549000000,
    currentBalance: 4321550000,
    totalDebt: 4503510000,
    riskLevel: 'Thấp',
    riskScore: 5,
    createdDate: '12/02/2026 09:13',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH073',
    code: 'C00127',
    name: 'Ngô Minh Bình',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 90 9912',
    email: 'ngminhbnh@email.com',
    idNumber: '48588904221',
    creditLimit: 1378000000,
    currentBalance: 1240200000,
    totalDebt: 1226420000,
    riskLevel: 'Trung bình',
    riskScore: 17,
    createdDate: '29/01/2026 16:52',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH074',
    code: 'C00128',
    name: 'Phạm Phương Nhung',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 94 6118',
    email: 'phmphngnhung@email.com',
    idNumber: '47695997124',
    creditLimit: 4363000000,
    currentBalance: 3621290000,
    totalDebt: 4319370000,
    riskLevel: 'Trung bình',
    riskScore: 17,
    createdDate: '22/03/2026 10:34',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH075',
    code: 'C00129',
    name: 'Công ty Hợp danh Cơ khí chế tạo',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Sản xuất',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 97 5336',
    email: 'cngtyhpdanhckhchto@email.com',
    idNumber: '96546658010',
    creditLimit: 1305000000,
    currentBalance: 1213650000,
    totalDebt: 1226700000,
    riskLevel: 'Cao',
    riskScore: 23,
    createdDate: '02/12/2025 09:12',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH076',
    code: 'C00130',
    name: 'Hoàng Hữu Giang',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 99 5681',
    email: 'honghugiang@email.com',
    idNumber: '14381253575',
    creditLimit: 4805000000,
    currentBalance: 3844000000,
    totalDebt: 4564750000,
    riskLevel: 'Cao',
    riskScore: 21,
    createdDate: '06/04/2026 11:43',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH077',
    code: 'C00131',
    name: 'Tô Anh Hương',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 98 7503',
    email: 'tanhhng@email.com',
    idNumber: '82293028397',
    creditLimit: 3993000000,
    currentBalance: 3833280000,
    totalDebt: 3473910000,
    riskLevel: 'Cao',
    riskScore: 20,
    createdDate: '07/03/2026 13:27',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH078',
    code: 'C00132',
    name: 'Công ty Hợp danh Sản xuất thực phẩm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Dịch vụ',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 94 7477',
    email: 'cngtyhpdanhsnxutthcphm@email.com',
    idNumber: '57430771635',
    creditLimit: 2141000000,
    currentBalance: 1755620000,
    totalDebt: 2033950000,
    riskLevel: 'Cao',
    riskScore: 27,
    createdDate: '27/03/2026 12:17',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH079',
    code: 'C00133',
    name: 'Lê Minh Khoa',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 96 6310',
    email: 'lminhkhoa@email.com',
    idNumber: '40954199266',
    creditLimit: 3130000000,
    currentBalance: 2879600000,
    totalDebt: 3067400000,
    riskLevel: 'Cao',
    riskScore: 29,
    createdDate: '25/02/2026 17:43',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH080',
    code: 'C00134',
    name: 'Đỗ Thu Hiếu',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 91 9753',
    email: 'thuhiu@email.com',
    idNumber: '97274061589',
    creditLimit: 4125000000,
    currentBalance: 3630000000,
    totalDebt: 3671250000,
    riskLevel: 'Trung bình',
    riskScore: 12,
    createdDate: '25/02/2026 17:51',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH081',
    code: 'C00135',
    name: 'Công ty Nhà nước Sản xuất thực phẩm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Vận tải',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 95 6522',
    email: 'cngtynhncsnxutthcphm@email.com',
    idNumber: '72477978337',
    creditLimit: 4663000000,
    currentBalance: 4150070000,
    totalDebt: 4523110000,
    riskLevel: 'Cao',
    riskScore: 27,
    createdDate: '02/12/2025 11:59',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH082',
    code: 'C00136',
    name: 'Đinh Thu Long',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 97 1355',
    email: 'inhthulong@email.com',
    idNumber: '53825157474',
    creditLimit: 4526000000,
    currentBalance: 4118660000,
    totalDebt: 4390220000,
    riskLevel: 'Cao',
    riskScore: 29,
    createdDate: '01/01/2026 14:57',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH083',
    code: 'C00137',
    name: 'Phạm Phương Trang',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 96 6089',
    email: 'phmphngtrang@email.com',
    idNumber: '27378021641',
    creditLimit: 3105000000,
    currentBalance: 3011850000,
    totalDebt: 2918700000,
    riskLevel: 'Cao',
    riskScore: 20,
    createdDate: '12/04/2026 15:24',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH084',
    code: 'C00138',
    name: 'Công ty Nhà nước May mặc xuất khẩu',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Xây dựng',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 95 7940',
    email: 'cngtynhncmaymcxutkhu@email.com',
    idNumber: '96475810457',
    creditLimit: 3228000000,
    currentBalance: 3034320000,
    totalDebt: 3098880000,
    riskLevel: 'Trung bình',
    riskScore: 14,
    createdDate: '30/01/2026 14:56',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH085',
    code: 'C00139',
    name: 'Phạm Minh Tâm',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 95 6641',
    email: 'phmminhtm@email.com',
    idNumber: '29928599592',
    creditLimit: 1570000000,
    currentBalance: 1271700000,
    totalDebt: 1475800000,
    riskLevel: 'Thấp',
    riskScore: 7,
    createdDate: '16/04/2026 17:32',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH086',
    code: 'C00140',
    name: 'Đặng Anh Xuân',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 96 9691',
    email: 'nganhxun@email.com',
    idNumber: '48881892208',
    creditLimit: 3545000000,
    currentBalance: 3403200000,
    totalDebt: 3119600000,
    riskLevel: 'Trung bình',
    riskScore: 12,
    createdDate: '19/01/2026 11:00',
    createdBy: 'Nguyễn Văn A',
    status: 'active',
  },
  {
    id: 'KH087',
    code: 'C00141',
    name: 'Công ty Nhà nước Nông nghiệp công nghệ cao',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Vận tải',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 91 6948',
    email: 'cngtynhncnngnghipcngnghcao@email.com',
    idNumber: '43077085861',
    creditLimit: 1775000000,
    currentBalance: 1562000000,
    totalDebt: 1739500000,
    riskLevel: 'Trung bình',
    riskScore: 11,
    createdDate: '03/04/2026 16:10',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH088',
    code: 'C00142',
    name: 'Đinh Phương Linh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 92 9231',
    email: 'inhphnglinh@email.com',
    idNumber: '79278727243',
    creditLimit: 2767000000,
    currentBalance: 2573310000,
    totalDebt: 2600980000,
    riskLevel: 'Thấp',
    riskScore: 9,
    createdDate: '20/04/2026 11:06',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH089',
    code: 'C00143',
    name: 'Đinh Minh Cường',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 93 3933',
    email: 'inhminhcng@email.com',
    idNumber: '22054835711',
    creditLimit: 3877000000,
    currentBalance: 3489300000,
    totalDebt: 3721920000,
    riskLevel: 'Cao',
    riskScore: 23,
    createdDate: '10/02/2026 08:56',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH090',
    code: 'C00144',
    name: 'Công ty Hợp danh Nông nghiệp công nghệ cao',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Y tế',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 90 2237',
    email: 'cngtyhpdanhnngnghipcngnghcao@email.com',
    idNumber: '91562133398',
    creditLimit: 909000000,
    currentBalance: 799920000,
    totalDebt: 899910000,
    riskLevel: 'Trung bình',
    riskScore: 11,
    createdDate: '27/05/2026 09:14',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH091',
    code: 'C00145',
    name: 'Dương Anh Tuấn',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 99 9450',
    email: 'dnganhtun@email.com',
    idNumber: '99356226620',
    creditLimit: 3105000000,
    currentBalance: 2701350000,
    totalDebt: 2918700000,
    riskLevel: 'Trung bình',
    riskScore: 11,
    createdDate: '04/05/2026 16:23',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH092',
    code: 'C00146',
    name: 'Đặng Thanh Khoa',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 94 8960',
    email: 'ngthanhkhoa@email.com',
    idNumber: '18055870473',
    creditLimit: 1145000000,
    currentBalance: 984700000,
    totalDebt: 973250000,
    riskLevel: 'Cao',
    riskScore: 24,
    createdDate: '24/02/2026 13:26',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH093',
    code: 'C00147',
    name: 'Công ty Cổ phần Dược phẩm',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Năng lượng',
    branch: 'CN TP HCM',
    address: 'TP HCM',
    phone: '+84 98 1879',
    email: 'cngtycphndcphm@email.com',
    idNumber: '23178840330',
    creditLimit: 1753000000,
    currentBalance: 1454990000,
    totalDebt: 1735470000,
    riskLevel: 'Trung bình',
    riskScore: 15,
    createdDate: '13/01/2026 17:39',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH094',
    code: 'C00148',
    name: 'Mai Văn Trang',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Nha Trang – Khánh Hòa',
    address: 'Nha Trang – Khánh Hòa',
    phone: '+84 91 1138',
    email: 'maivntrang@email.com',
    idNumber: '41939385526',
    creditLimit: 4508000000,
    currentBalance: 4372760000,
    totalDebt: 3876880000,
    riskLevel: 'Cao',
    riskScore: 26,
    createdDate: '02/05/2026 16:06',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH095',
    code: 'C00149',
    name: 'Lê Anh Oanh',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 96 7325',
    email: 'lanhoanh@email.com',
    idNumber: '45673030590',
    creditLimit: 4997000000,
    currentBalance: 4047570000,
    totalDebt: 4347390000,
    riskLevel: 'Cao',
    riskScore: 22,
    createdDate: '28/03/2026 09:27',
    createdBy: 'Hoàng Văn E',
    status: 'active',
  },
  {
    id: 'KH096',
    code: 'C00150',
    name: 'Công ty Tư nhân Dịch vụ logistics',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Công nghệ',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 92 1096',
    email: 'cngtytnhndchvlogistics@email.com',
    idNumber: '23932160048',
    creditLimit: 1474000000,
    currentBalance: 1400300000,
    totalDebt: 1282380000,
    riskLevel: 'Thấp',
    riskScore: 5,
    createdDate: '27/01/2026 15:34',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH097',
    code: 'C00151',
    name: 'Nguyễn Thanh Hiếu',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hải Phòng',
    address: 'Hải Phòng',
    phone: '+84 94 2705',
    email: 'nguynthanhhiu@email.com',
    idNumber: '32050048587',
    creditLimit: 938000000,
    currentBalance: 862960000,
    totalDebt: 834820000,
    riskLevel: 'Thấp',
    riskScore: 7,
    createdDate: '21/02/2026 14:22',
    createdBy: 'Phạm Thị D',
    status: 'active',
  },
  {
    id: 'KH098',
    code: 'C00152',
    name: 'Nguyễn Thị Giang',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Cần Thơ',
    address: 'Cần Thơ',
    phone: '+84 96 1189',
    email: 'nguynthgiang@email.com',
    idNumber: '19981857032',
    creditLimit: 2378000000,
    currentBalance: 1973740000,
    totalDebt: 2021300000,
    riskLevel: 'Trung bình',
    riskScore: 13,
    createdDate: '01/12/2025 09:57',
    createdBy: 'Lê Văn C',
    status: 'active',
  },
  {
    id: 'KH099',
    code: 'C00153',
    name: 'Công ty Hợp danh Phát triển bất động sản',
    type: 'Khách hàng doanh nghiệp',
    industry: 'Y tế',
    branch: 'CN Đà Nẵng',
    address: 'Đà Nẵng',
    phone: '+84 96 1323',
    email: 'cngtyhpdanhphttrinbtngsn@email.com',
    idNumber: '85146403097',
    creditLimit: 4238000000,
    currentBalance: 4026100000,
    totalDebt: 3602300000,
    riskLevel: 'Thấp',
    riskScore: 1,
    createdDate: '14/04/2026 17:55',
    createdBy: 'Trần Thị B',
    status: 'active',
  },
  {
    id: 'KH100',
    code: 'C00154',
    name: 'Hoàng Văn Uyên',
    type: 'Khách hàng cá nhân',
    industry: 'Cá nhân',
    branch: 'CN Hà Nội',
    address: 'Hà Nội',
    phone: '+84 98 5184',
    email: 'hongvnuyn@email.com',
    idNumber: '42558948912',
    creditLimit: 153000000,
    currentBalance: 125460000,
    totalDebt: 130050000,
    riskLevel: 'Cao',
    riskScore: 26,
    createdDate: '19/04/2026 09:43',
    createdBy: 'Lê Văn C',
    status: 'active',
  }
];

export const extendedWarnings = [
  {
    id: 'WRN-000129',
    code: 'WRN-000129',
    customerId: 'KH033',
    customerCode: 'C00087',
    customerName: 'Customer C00087',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00087',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-30 21:21',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-30 21:21',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000064',
    code: 'WRN-000064',
    customerId: 'KH064',
    customerCode: 'C00118',
    customerName: 'Customer C00118',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00118',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 16',
    status: 'in_progress',
    createdDate: '2026-05-30 19:52',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-30 19:52',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000343',
    code: 'WRN-000343',
    customerId: 'KH030',
    customerCode: 'C00084',
    customerName: 'Customer C00084',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00084',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-30 17:22',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-30 17:22',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000204',
    code: 'WRN-000204',
    customerId: 'KH038',
    customerCode: 'C00092',
    customerName: 'Customer C00092',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00092',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 17',
    status: 'in_progress',
    createdDate: '2026-05-30 17:21',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-30 17:21',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000159',
    code: 'WRN-000159',
    customerId: 'KH004',
    customerCode: 'C00058',
    customerName: 'Customer C00058',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00058',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 30',
    status: 'in_progress',
    createdDate: '2026-05-30 14:35',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-30 14:35',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000326',
    code: 'WRN-000326',
    customerId: 'KH044',
    customerCode: 'C00098',
    customerName: 'Customer C00098',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00098',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 16',
    status: 'resolved',
    createdDate: '2026-05-30 13:36',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-30 13:36',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-06-12 13:36',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000412',
    code: 'WRN-000412',
    customerId: 'KH018',
    customerCode: 'C00072',
    customerName: 'Customer C00072',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00072',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-30 10:07',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-30 10:07',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000313',
    code: 'WRN-000313',
    customerId: 'KH063',
    customerCode: 'C00117',
    customerName: 'Customer C00117',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00117',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 23',
    status: 'new',
    createdDate: '2026-05-30 09:38',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-30 09:38',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000406',
    code: 'WRN-000406',
    customerId: 'KH056',
    customerCode: 'C00110',
    customerName: 'Customer C00110',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00110',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 20',
    status: 'new',
    createdDate: '2026-05-30 09:06',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-30 09:06',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000109',
    code: 'WRN-000109',
    customerId: 'KH037',
    customerCode: 'C00091',
    customerName: 'Customer C00091',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00091',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 21',
    status: 'new',
    createdDate: '2026-05-30 07:41',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-30 07:41',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000069',
    code: 'WRN-000069',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 12',
    status: 'new',
    createdDate: '2026-05-30 07:22',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-30 07:22',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000136',
    code: 'WRN-000136',
    customerId: 'KH027',
    customerCode: 'C00081',
    customerName: 'Customer C00081',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00081',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 7',
    status: 'new',
    createdDate: '2026-05-30 07:04',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-30 07:04',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000062',
    code: 'WRN-000062',
    customerId: 'KH045',
    customerCode: 'C00099',
    customerName: 'Customer C00099',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00099',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 23',
    status: 'new',
    createdDate: '2026-05-30 06:45',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-30 06:45',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000199',
    code: 'WRN-000199',
    customerId: 'KH094',
    customerCode: 'C00148',
    customerName: 'Customer C00148',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00148',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 16',
    status: 'in_progress',
    createdDate: '2026-05-30 06:15',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-30 06:15',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000058',
    code: 'WRN-000058',
    customerId: 'KH009',
    customerCode: 'C00063',
    customerName: 'Customer C00063',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00063',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 24',
    status: 'resolved',
    createdDate: '2026-05-30 05:45',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-30 05:45',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-06-10 05:45',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000071',
    code: 'WRN-000071',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 24',
    status: 'in_progress',
    createdDate: '2026-05-30 01:46',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-30 01:46',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000247',
    code: 'WRN-000247',
    customerId: 'KH006',
    customerCode: 'C00060',
    customerName: 'Customer C00060',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-008',
    indicatorName: 'Indicator IND-BEH-008',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00060',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-008 vượt ngưỡng với điểm 6',
    status: 'in_progress',
    createdDate: '2026-05-29 23:23',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-29 23:23',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000024',
    code: 'WRN-000024',
    customerId: 'KH089',
    customerCode: 'C00143',
    customerName: 'Customer C00143',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00143',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 1',
    status: 'resolved',
    createdDate: '2026-05-29 23:20',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-29 23:20',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-31 23:20',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000217',
    code: 'WRN-000217',
    customerId: 'KH094',
    customerCode: 'C00148',
    customerName: 'Customer C00148',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00148',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 6',
    status: 'resolved',
    createdDate: '2026-05-29 15:30',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-29 15:30',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-06-13 15:30',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000004',
    code: 'WRN-000004',
    customerId: 'KH035',
    customerCode: 'C00089',
    customerName: 'Customer C00089',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00089',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 6',
    status: 'in_progress',
    createdDate: '2026-05-29 15:26',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-29 15:26',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000414',
    code: 'WRN-000414',
    customerId: 'KH063',
    customerCode: 'C00117',
    customerName: 'Customer C00117',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00117',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 23',
    status: 'new',
    createdDate: '2026-05-29 14:20',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-29 14:20',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000469',
    code: 'WRN-000469',
    customerId: 'KH060',
    customerCode: 'C00114',
    customerName: 'Customer C00114',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00114',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 23',
    status: 'in_progress',
    createdDate: '2026-05-29 12:43',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-29 12:43',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000282',
    code: 'WRN-000282',
    customerId: 'KH091',
    customerCode: 'C00145',
    customerName: 'Customer C00145',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00145',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 12',
    status: 'in_progress',
    createdDate: '2026-05-29 12:36',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-29 12:36',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000245',
    code: 'WRN-000245',
    customerId: 'KH023',
    customerCode: 'C00077',
    customerName: 'Customer C00077',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00077',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 29',
    status: 'in_progress',
    createdDate: '2026-05-29 12:14',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-29 12:14',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000363',
    code: 'WRN-000363',
    customerId: 'KH062',
    customerCode: 'C00116',
    customerName: 'Customer C00116',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00116',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 18',
    status: 'resolved',
    createdDate: '2026-05-29 11:23',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-29 11:23',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-06-05 11:23',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000458',
    code: 'WRN-000458',
    customerId: 'KH036',
    customerCode: 'C00090',
    customerName: 'Customer C00090',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-007',
    indicatorName: 'Indicator IND-PAY-007',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00090',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-007 vượt ngưỡng với điểm 21',
    status: 'new',
    createdDate: '2026-05-29 09:20',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-29 09:20',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000367',
    code: 'WRN-000367',
    customerId: 'KH047',
    customerCode: 'C00101',
    customerName: 'Customer C00101',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00101',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-29 05:26',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-29 05:26',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000050',
    code: 'WRN-000050',
    customerId: 'KH097',
    customerCode: 'C00151',
    customerName: 'Customer C00151',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00151',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 15',
    status: 'new',
    createdDate: '2026-05-29 02:53',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-29 02:53',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000178',
    code: 'WRN-000178',
    customerId: 'KH023',
    customerCode: 'C00077',
    customerName: 'Customer C00077',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00077',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 12',
    status: 'new',
    createdDate: '2026-05-28 23:33',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-28 23:33',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000410',
    code: 'WRN-000410',
    customerId: 'KH016',
    customerCode: 'C00070',
    customerName: 'Customer C00070',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00070',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 25',
    status: 'new',
    createdDate: '2026-05-28 17:17',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-28 17:17',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000086',
    code: 'WRN-000086',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 22',
    status: 'resolved',
    createdDate: '2026-05-28 16:18',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-28 16:18',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-29 16:18',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000117',
    code: 'WRN-000117',
    customerId: 'KH048',
    customerCode: 'C00102',
    customerName: 'Customer C00102',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00102',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 1',
    status: 'resolved',
    createdDate: '2026-05-28 15:46',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-28 15:46',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-06-04 15:46',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000143',
    code: 'WRN-000143',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-28 14:39',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-28 14:39',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000303',
    code: 'WRN-000303',
    customerId: 'KH100',
    customerCode: 'C00154',
    customerName: 'Customer C00154',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00154',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 10',
    status: 'in_progress',
    createdDate: '2026-05-28 13:08',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-28 13:08',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000446',
    code: 'WRN-000446',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-008',
    indicatorName: 'Indicator IND-BEH-008',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-008 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-28 12:03',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-28 12:03',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000262',
    code: 'WRN-000262',
    customerId: 'KH016',
    customerCode: 'C00070',
    customerName: 'Customer C00070',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00070',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 30',
    status: 'in_progress',
    createdDate: '2026-05-28 11:56',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-28 11:56',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000305',
    code: 'WRN-000305',
    customerId: 'KH015',
    customerCode: 'C00069',
    customerName: 'Customer C00069',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00069',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 27',
    status: 'new',
    createdDate: '2026-05-28 11:00',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-28 11:00',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000090',
    code: 'WRN-000090',
    customerId: 'KH060',
    customerCode: 'C00114',
    customerName: 'Customer C00114',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00114',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-28 06:53',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-28 06:53',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000396',
    code: 'WRN-000396',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 28',
    status: 'in_progress',
    createdDate: '2026-05-28 06:19',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-28 06:19',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000054',
    code: 'WRN-000054',
    customerId: 'KH092',
    customerCode: 'C00146',
    customerName: 'Customer C00146',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00146',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-28 06:14',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-28 06:14',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000195',
    code: 'WRN-000195',
    customerId: 'KH022',
    customerCode: 'C00076',
    customerName: 'Customer C00076',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00076',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 6',
    status: 'in_progress',
    createdDate: '2026-05-28 05:56',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-28 05:56',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000218',
    code: 'WRN-000218',
    customerId: 'KH028',
    customerCode: 'C00082',
    customerName: 'Customer C00082',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00082',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-28 05:35',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-28 05:35',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000392',
    code: 'WRN-000392',
    customerId: 'KH059',
    customerCode: 'C00113',
    customerName: 'Customer C00113',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00113',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 26',
    status: 'new',
    createdDate: '2026-05-28 03:01',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-28 03:01',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000286',
    code: 'WRN-000286',
    customerId: 'KH050',
    customerCode: 'C00104',
    customerName: 'Customer C00104',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00104',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 3',
    status: 'resolved',
    createdDate: '2026-05-28 02:18',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-28 02:18',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-06-12 02:18',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000318',
    code: 'WRN-000318',
    customerId: 'KH061',
    customerCode: 'C00115',
    customerName: 'Customer C00115',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00115',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 6',
    status: 'in_progress',
    createdDate: '2026-05-28 01:02',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-28 01:02',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000486',
    code: 'WRN-000486',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-28 00:10',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-28 00:10',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000483',
    code: 'WRN-000483',
    customerId: 'KH074',
    customerCode: 'C00128',
    customerName: 'Customer C00128',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00128',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-28 00:08',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-28 00:08',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000347',
    code: 'WRN-000347',
    customerId: 'KH080',
    customerCode: 'C00134',
    customerName: 'Customer C00134',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00134',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 12',
    status: 'resolved',
    createdDate: '2026-05-27 22:09',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-27 22:09',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-31 22:09',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000271',
    code: 'WRN-000271',
    customerId: 'KH079',
    customerCode: 'C00133',
    customerName: 'Customer C00133',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00133',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 23',
    status: 'in_progress',
    createdDate: '2026-05-27 20:52',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-27 20:52',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000456',
    code: 'WRN-000456',
    customerId: 'KH099',
    customerCode: 'C00153',
    customerName: 'Customer C00153',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-008',
    indicatorName: 'Indicator IND-FIN-008',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00153',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-008 vượt ngưỡng với điểm 15',
    status: 'new',
    createdDate: '2026-05-27 18:53',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-27 18:53',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000025',
    code: 'WRN-000025',
    customerId: 'KH004',
    customerCode: 'C00058',
    customerName: 'Customer C00058',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00058',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 1',
    status: 'new',
    createdDate: '2026-05-27 14:26',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-27 14:26',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000433',
    code: 'WRN-000433',
    customerId: 'KH056',
    customerCode: 'C00110',
    customerName: 'Customer C00110',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00110',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 12',
    status: 'resolved',
    createdDate: '2026-05-27 12:38',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-27 12:38',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-06-05 12:38',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000280',
    code: 'WRN-000280',
    customerId: 'KH087',
    customerCode: 'C00141',
    customerName: 'Customer C00141',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00141',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 8',
    status: 'in_progress',
    createdDate: '2026-05-27 11:11',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-27 11:11',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000116',
    code: 'WRN-000116',
    customerId: 'KH009',
    customerCode: 'C00063',
    customerName: 'Customer C00063',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00063',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 16',
    status: 'in_progress',
    createdDate: '2026-05-27 10:49',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-27 10:49',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000132',
    code: 'WRN-000132',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 19',
    status: 'resolved',
    createdDate: '2026-05-27 08:09',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-27 08:09',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-31 08:09',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000229',
    code: 'WRN-000229',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 18',
    status: 'in_progress',
    createdDate: '2026-05-27 06:10',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-27 06:10',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000122',
    code: 'WRN-000122',
    customerId: 'KH054',
    customerCode: 'C00108',
    customerName: 'Customer C00108',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00108',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-27 05:00',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-27 05:00',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000053',
    code: 'WRN-000053',
    customerId: 'KH055',
    customerCode: 'C00109',
    customerName: 'Customer C00109',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00109',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 5',
    status: 'in_progress',
    createdDate: '2026-05-27 04:08',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-27 04:08',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000202',
    code: 'WRN-000202',
    customerId: 'KH044',
    customerCode: 'C00098',
    customerName: 'Customer C00098',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00098',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 11',
    status: 'in_progress',
    createdDate: '2026-05-27 03:20',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-27 03:20',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000110',
    code: 'WRN-000110',
    customerId: 'KH024',
    customerCode: 'C00078',
    customerName: 'Customer C00078',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00078',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-27 01:37',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-27 01:37',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000484',
    code: 'WRN-000484',
    customerId: 'KH035',
    customerCode: 'C00089',
    customerName: 'Customer C00089',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00089',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-26 23:46',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-26 23:46',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000447',
    code: 'WRN-000447',
    customerId: 'KH028',
    customerCode: 'C00082',
    customerName: 'Customer C00082',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00082',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 8',
    status: 'in_progress',
    createdDate: '2026-05-26 23:34',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-26 23:34',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000428',
    code: 'WRN-000428',
    customerId: 'KH025',
    customerCode: 'C00079',
    customerName: 'Customer C00079',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00079',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 10',
    status: 'resolved',
    createdDate: '2026-05-26 23:30',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-26 23:30',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-31 23:30',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000423',
    code: 'WRN-000423',
    customerId: 'KH100',
    customerCode: 'C00154',
    customerName: 'Customer C00154',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00154',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 12',
    status: 'in_progress',
    createdDate: '2026-05-26 23:18',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-26 23:18',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000323',
    code: 'WRN-000323',
    customerId: 'KH093',
    customerCode: 'C00147',
    customerName: 'Customer C00147',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-007',
    indicatorName: 'Indicator IND-PAY-007',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00147',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-007 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-26 23:02',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-26 23:02',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000033',
    code: 'WRN-000033',
    customerId: 'KH045',
    customerCode: 'C00099',
    customerName: 'Customer C00099',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00099',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-26 22:21',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-26 22:21',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000370',
    code: 'WRN-000370',
    customerId: 'KH050',
    customerCode: 'C00104',
    customerName: 'Customer C00104',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00104',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 9',
    status: 'resolved',
    createdDate: '2026-05-26 18:29',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-26 18:29',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-06-04 18:29',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000297',
    code: 'WRN-000297',
    customerId: 'KH032',
    customerCode: 'C00086',
    customerName: 'Customer C00086',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00086',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-26 16:22',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-26 16:22',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-30 16:22',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000232',
    code: 'WRN-000232',
    customerId: 'KH096',
    customerCode: 'C00150',
    customerName: 'Customer C00150',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00150',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 27',
    status: 'in_progress',
    createdDate: '2026-05-26 15:20',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-26 15:20',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000127',
    code: 'WRN-000127',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 7',
    status: 'new',
    createdDate: '2026-05-26 13:12',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-26 13:12',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000421',
    code: 'WRN-000421',
    customerId: 'KH049',
    customerCode: 'C00103',
    customerName: 'Customer C00103',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00103',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-26 12:35',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-26 12:35',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000186',
    code: 'WRN-000186',
    customerId: 'KH087',
    customerCode: 'C00141',
    customerName: 'Customer C00141',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00141',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-26 11:23',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-26 11:23',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000425',
    code: 'WRN-000425',
    customerId: 'KH055',
    customerCode: 'C00109',
    customerName: 'Customer C00109',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00109',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-26 09:08',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-26 09:08',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000322',
    code: 'WRN-000322',
    customerId: 'KH024',
    customerCode: 'C00078',
    customerName: 'Customer C00078',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00078',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 30',
    status: 'new',
    createdDate: '2026-05-26 07:18',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-26 07:18',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000039',
    code: 'WRN-000039',
    customerId: 'KH069',
    customerCode: 'C00123',
    customerName: 'Customer C00123',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00123',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 11',
    status: 'new',
    createdDate: '2026-05-26 06:02',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-26 06:02',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000441',
    code: 'WRN-000441',
    customerId: 'KH064',
    customerCode: 'C00118',
    customerName: 'Customer C00118',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00118',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 2',
    status: 'in_progress',
    createdDate: '2026-05-26 01:12',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-26 01:12',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000240',
    code: 'WRN-000240',
    customerId: 'KH054',
    customerCode: 'C00108',
    customerName: 'Customer C00108',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00108',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-25 22:38',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-25 22:38',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000112',
    code: 'WRN-000112',
    customerId: 'KH003',
    customerCode: 'C00057',
    customerName: 'Customer C00057',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00057',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-25 21:00',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-25 21:00',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000342',
    code: 'WRN-000342',
    customerId: 'KH014',
    customerCode: 'C00068',
    customerName: 'Customer C00068',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00068',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 13',
    status: 'resolved',
    createdDate: '2026-05-25 20:22',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-25 20:22',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: '2026-05-26 20:22',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000291',
    code: 'WRN-000291',
    customerId: 'KH040',
    customerCode: 'C00094',
    customerName: 'Customer C00094',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00094',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 21',
    status: 'new',
    createdDate: '2026-05-25 18:22',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-25 18:22',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000492',
    code: 'WRN-000492',
    customerId: 'KH085',
    customerCode: 'C00139',
    customerName: 'Customer C00139',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00139',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 14',
    status: 'resolved',
    createdDate: '2026-05-25 15:02',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-25 15:02',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-06-08 15:02',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000144',
    code: 'WRN-000144',
    customerId: 'KH010',
    customerCode: 'C00064',
    customerName: 'Customer C00064',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00064',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 30',
    status: 'new',
    createdDate: '2026-05-25 14:49',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-25 14:49',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000215',
    code: 'WRN-000215',
    customerId: 'KH100',
    customerCode: 'C00154',
    customerName: 'Customer C00154',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00154',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 22',
    status: 'in_progress',
    createdDate: '2026-05-25 13:46',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-25 13:46',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000085',
    code: 'WRN-000085',
    customerId: 'KH075',
    customerCode: 'C00129',
    customerName: 'Customer C00129',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00129',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 24',
    status: 'in_progress',
    createdDate: '2026-05-25 10:50',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-25 10:50',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000066',
    code: 'WRN-000066',
    customerId: 'KH016',
    customerCode: 'C00070',
    customerName: 'Customer C00070',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00070',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 4',
    status: 'in_progress',
    createdDate: '2026-05-25 09:23',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-25 09:23',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000120',
    code: 'WRN-000120',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 28',
    status: 'new',
    createdDate: '2026-05-25 08:41',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-25 08:41',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000038',
    code: 'WRN-000038',
    customerId: 'KH059',
    customerCode: 'C00113',
    customerName: 'Customer C00113',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00113',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 3',
    status: 'in_progress',
    createdDate: '2026-05-25 08:37',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-25 08:37',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000201',
    code: 'WRN-000201',
    customerId: 'KH079',
    customerCode: 'C00133',
    customerName: 'Customer C00133',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00133',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 18',
    status: 'resolved',
    createdDate: '2026-05-25 07:30',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-25 07:30',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-26 07:30',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000009',
    code: 'WRN-000009',
    customerId: 'KH045',
    customerCode: 'C00099',
    customerName: 'Customer C00099',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00099',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 2',
    status: 'in_progress',
    createdDate: '2026-05-25 04:33',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-25 04:33',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000019',
    code: 'WRN-000019',
    customerId: 'KH095',
    customerCode: 'C00149',
    customerName: 'Customer C00149',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-007',
    indicatorName: 'Indicator IND-PAY-007',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00149',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-007 vượt ngưỡng với điểm 3',
    status: 'new',
    createdDate: '2026-05-25 02:58',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-25 02:58',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000030',
    code: 'WRN-000030',
    customerId: 'KH024',
    customerCode: 'C00078',
    customerName: 'Customer C00078',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00078',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 25',
    status: 'resolved',
    createdDate: '2026-05-25 02:48',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-25 02:48',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-31 02:48',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000126',
    code: 'WRN-000126',
    customerId: 'KH031',
    customerCode: 'C00085',
    customerName: 'Customer C00085',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00085',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 6',
    status: 'in_progress',
    createdDate: '2026-05-25 01:41',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-25 01:41',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000279',
    code: 'WRN-000279',
    customerId: 'KH027',
    customerCode: 'C00081',
    customerName: 'Customer C00081',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00081',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 3',
    status: 'in_progress',
    createdDate: '2026-05-25 01:25',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-25 01:25',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000263',
    code: 'WRN-000263',
    customerId: 'KH057',
    customerCode: 'C00111',
    customerName: 'Customer C00111',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00111',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 9',
    status: 'in_progress',
    createdDate: '2026-05-25 00:57',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-25 00:57',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000356',
    code: 'WRN-000356',
    customerId: 'KH070',
    customerCode: 'C00124',
    customerName: 'Customer C00124',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-008',
    indicatorName: 'Indicator IND-FIN-008',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00124',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-008 vượt ngưỡng với điểm 7',
    status: 'new',
    createdDate: '2026-05-24 23:27',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-24 23:27',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000308',
    code: 'WRN-000308',
    customerId: 'KH071',
    customerCode: 'C00125',
    customerName: 'Customer C00125',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00125',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-24 21:37',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-24 21:37',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000300',
    code: 'WRN-000300',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 15',
    status: 'new',
    createdDate: '2026-05-24 20:30',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-24 20:30',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000341',
    code: 'WRN-000341',
    customerId: 'KH028',
    customerCode: 'C00082',
    customerName: 'Customer C00082',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00082',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-24 18:59',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-24 18:59',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000478',
    code: 'WRN-000478',
    customerId: 'KH060',
    customerCode: 'C00114',
    customerName: 'Customer C00114',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00114',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-24 18:58',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-24 18:58',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000339',
    code: 'WRN-000339',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-24 18:23',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-24 18:23',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000364',
    code: 'WRN-000364',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 3',
    status: 'new',
    createdDate: '2026-05-24 13:07',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-24 13:07',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000032',
    code: 'WRN-000032',
    customerId: 'KH076',
    customerCode: 'C00130',
    customerName: 'Customer C00130',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00130',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 10',
    status: 'new',
    createdDate: '2026-05-24 12:43',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-24 12:43',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000383',
    code: 'WRN-000383',
    customerId: 'KH055',
    customerCode: 'C00109',
    customerName: 'Customer C00109',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00109',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-24 12:07',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-24 12:07',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000042',
    code: 'WRN-000042',
    customerId: 'KH033',
    customerCode: 'C00087',
    customerName: 'Customer C00087',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00087',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 16',
    status: 'in_progress',
    createdDate: '2026-05-24 10:50',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-24 10:50',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000273',
    code: 'WRN-000273',
    customerId: 'KH083',
    customerCode: 'C00137',
    customerName: 'Customer C00137',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00137',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 22',
    status: 'in_progress',
    createdDate: '2026-05-24 07:46',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-24 07:46',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000470',
    code: 'WRN-000470',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-24 07:46',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-24 07:46',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000472',
    code: 'WRN-000472',
    customerId: 'KH007',
    customerCode: 'C00061',
    customerName: 'Customer C00061',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00061',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-24 07:03',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-24 07:03',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-31 07:03',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000292',
    code: 'WRN-000292',
    customerId: 'KH098',
    customerCode: 'C00152',
    customerName: 'Customer C00152',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00152',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 8',
    status: 'resolved',
    createdDate: '2026-05-24 06:12',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-24 06:12',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-29 06:12',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000452',
    code: 'WRN-000452',
    customerId: 'KH061',
    customerCode: 'C00115',
    customerName: 'Customer C00115',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00115',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-24 04:27',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-24 04:27',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000463',
    code: 'WRN-000463',
    customerId: 'KH086',
    customerCode: 'C00140',
    customerName: 'Customer C00140',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00140',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 20',
    status: 'new',
    createdDate: '2026-05-24 04:21',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-24 04:21',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000358',
    code: 'WRN-000358',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 30',
    status: 'new',
    createdDate: '2026-05-24 00:01',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-24 00:01',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000228',
    code: 'WRN-000228',
    customerId: 'KH094',
    customerCode: 'C00148',
    customerName: 'Customer C00148',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00148',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-23 18:06',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-23 18:06',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000330',
    code: 'WRN-000330',
    customerId: 'KH070',
    customerCode: 'C00124',
    customerName: 'Customer C00124',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00124',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 25',
    status: 'in_progress',
    createdDate: '2026-05-23 16:56',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-23 16:56',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000337',
    code: 'WRN-000337',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 25',
    status: 'in_progress',
    createdDate: '2026-05-23 15:22',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-23 15:22',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000417',
    code: 'WRN-000417',
    customerId: 'KH085',
    customerCode: 'C00139',
    customerName: 'Customer C00139',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00139',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-23 13:50',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-23 13:50',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000336',
    code: 'WRN-000336',
    customerId: 'KH032',
    customerCode: 'C00086',
    customerName: 'Customer C00086',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00086',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-23 11:14',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-23 11:14',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000213',
    code: 'WRN-000213',
    customerId: 'KH034',
    customerCode: 'C00088',
    customerName: 'Customer C00088',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00088',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-23 11:06',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-23 11:06',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000430',
    code: 'WRN-000430',
    customerId: 'KH071',
    customerCode: 'C00125',
    customerName: 'Customer C00125',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00125',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-23 10:09',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-23 10:09',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000333',
    code: 'WRN-000333',
    customerId: 'KH011',
    customerCode: 'C00065',
    customerName: 'Customer C00065',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00065',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 8',
    status: 'in_progress',
    createdDate: '2026-05-23 06:14',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-23 06:14',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000349',
    code: 'WRN-000349',
    customerId: 'KH089',
    customerCode: 'C00143',
    customerName: 'Customer C00143',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00143',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 4',
    status: 'in_progress',
    createdDate: '2026-05-23 05:37',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-23 05:37',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000055',
    code: 'WRN-000055',
    customerId: 'KH028',
    customerCode: 'C00082',
    customerName: 'Customer C00082',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00082',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 7',
    status: 'new',
    createdDate: '2026-05-23 04:05',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-23 04:05',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000389',
    code: 'WRN-000389',
    customerId: 'KH045',
    customerCode: 'C00099',
    customerName: 'Customer C00099',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-007',
    indicatorName: 'Indicator IND-PAY-007',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00099',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-007 vượt ngưỡng với điểm 12',
    status: 'in_progress',
    createdDate: '2026-05-23 02:54',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-23 02:54',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000462',
    code: 'WRN-000462',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 23',
    status: 'resolved',
    createdDate: '2026-05-23 02:49',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-23 02:49',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-28 02:49',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000345',
    code: 'WRN-000345',
    customerId: 'KH031',
    customerCode: 'C00085',
    customerName: 'Customer C00085',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00085',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-23 01:31',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-23 01:31',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000192',
    code: 'WRN-000192',
    customerId: 'KH002',
    customerCode: 'C00056',
    customerName: 'Customer C00056',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00056',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-23 00:26',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-23 00:26',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000464',
    code: 'WRN-000464',
    customerId: 'KH041',
    customerCode: 'C00095',
    customerName: 'Customer C00095',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00095',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 19',
    status: 'resolved',
    createdDate: '2026-05-22 22:43',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-22 22:43',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-31 22:43',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000374',
    code: 'WRN-000374',
    customerId: 'KH075',
    customerCode: 'C00129',
    customerName: 'Customer C00129',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00129',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 27',
    status: 'new',
    createdDate: '2026-05-22 22:18',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-22 22:18',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000372',
    code: 'WRN-000372',
    customerId: 'KH091',
    customerCode: 'C00145',
    customerName: 'Customer C00145',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00145',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 27',
    status: 'new',
    createdDate: '2026-05-22 21:14',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-22 21:14',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000211',
    code: 'WRN-000211',
    customerId: 'KH056',
    customerCode: 'C00110',
    customerName: 'Customer C00110',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00110',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 23',
    status: 'new',
    createdDate: '2026-05-22 20:40',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-22 20:40',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000023',
    code: 'WRN-000023',
    customerId: 'KH032',
    customerCode: 'C00086',
    customerName: 'Customer C00086',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00086',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-22 20:00',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-22 20:00',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000312',
    code: 'WRN-000312',
    customerId: 'KH070',
    customerCode: 'C00124',
    customerName: 'Customer C00124',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00124',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 15',
    status: 'new',
    createdDate: '2026-05-22 18:48',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-22 18:48',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000037',
    code: 'WRN-000037',
    customerId: 'KH011',
    customerCode: 'C00065',
    customerName: 'Customer C00065',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-008',
    indicatorName: 'Indicator IND-FIN-008',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00065',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-008 vượt ngưỡng với điểm 30',
    status: 'in_progress',
    createdDate: '2026-05-22 15:42',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-22 15:42',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000436',
    code: 'WRN-000436',
    customerId: 'KH049',
    customerCode: 'C00103',
    customerName: 'Customer C00103',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00103',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 25',
    status: 'new',
    createdDate: '2026-05-22 13:11',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-22 13:11',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000461',
    code: 'WRN-000461',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 12',
    status: 'resolved',
    createdDate: '2026-05-22 11:10',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-22 11:10',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-30 11:10',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000295',
    code: 'WRN-000295',
    customerId: 'KH019',
    customerCode: 'C00073',
    customerName: 'Customer C00073',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00073',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 9',
    status: 'in_progress',
    createdDate: '2026-05-22 09:39',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-22 09:39',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000250',
    code: 'WRN-000250',
    customerId: 'KH029',
    customerCode: 'C00083',
    customerName: 'Customer C00083',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00083',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-22 08:11',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-22 08:11',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000200',
    code: 'WRN-000200',
    customerId: 'KH068',
    customerCode: 'C00122',
    customerName: 'Customer C00122',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00122',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 11',
    status: 'new',
    createdDate: '2026-05-22 08:05',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-22 08:05',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000115',
    code: 'WRN-000115',
    customerId: 'KH056',
    customerCode: 'C00110',
    customerName: 'Customer C00110',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00110',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 25',
    status: 'in_progress',
    createdDate: '2026-05-22 06:00',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-22 06:00',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000194',
    code: 'WRN-000194',
    customerId: 'KH066',
    customerCode: 'C00120',
    customerName: 'Customer C00120',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-008',
    indicatorName: 'Indicator IND-BEH-008',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00120',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-008 vượt ngưỡng với điểm 14',
    status: 'new',
    createdDate: '2026-05-22 05:10',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-22 05:10',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000175',
    code: 'WRN-000175',
    customerId: 'KH011',
    customerCode: 'C00065',
    customerName: 'Customer C00065',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00065',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 24',
    status: 'resolved',
    createdDate: '2026-05-22 05:08',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-22 05:08',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-28 05:08',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000235',
    code: 'WRN-000235',
    customerId: 'KH023',
    customerCode: 'C00077',
    customerName: 'Customer C00077',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00077',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 8',
    status: 'in_progress',
    createdDate: '2026-05-22 02:47',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-22 02:47',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000020',
    code: 'WRN-000020',
    customerId: 'KH090',
    customerCode: 'C00144',
    customerName: 'Customer C00144',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00144',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 11',
    status: 'in_progress',
    createdDate: '2026-05-22 02:30',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-22 02:30',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000248',
    code: 'WRN-000248',
    customerId: 'KH084',
    customerCode: 'C00138',
    customerName: 'Customer C00138',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00138',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 26',
    status: 'in_progress',
    createdDate: '2026-05-22 00:58',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-22 00:58',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000015',
    code: 'WRN-000015',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-21 20:19',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-21 20:19',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000220',
    code: 'WRN-000220',
    customerId: 'KH092',
    customerCode: 'C00146',
    customerName: 'Customer C00146',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00146',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 4',
    status: 'in_progress',
    createdDate: '2026-05-21 20:15',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-21 20:15',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000445',
    code: 'WRN-000445',
    customerId: 'KH009',
    customerCode: 'C00063',
    customerName: 'Customer C00063',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00063',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 22',
    status: 'new',
    createdDate: '2026-05-21 20:13',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-21 20:13',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000187',
    code: 'WRN-000187',
    customerId: 'KH040',
    customerCode: 'C00094',
    customerName: 'Customer C00094',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00094',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 16',
    status: 'in_progress',
    createdDate: '2026-05-21 19:10',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-21 19:10',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000288',
    code: 'WRN-000288',
    customerId: 'KH053',
    customerCode: 'C00107',
    customerName: 'Customer C00107',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00107',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 24',
    status: 'in_progress',
    createdDate: '2026-05-21 17:05',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-21 17:05',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000051',
    code: 'WRN-000051',
    customerId: 'KH025',
    customerCode: 'C00079',
    customerName: 'Customer C00079',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00079',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-21 16:23',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-21 16:23',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000098',
    code: 'WRN-000098',
    customerId: 'KH070',
    customerCode: 'C00124',
    customerName: 'Customer C00124',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00124',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-21 13:24',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-21 13:24',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000029',
    code: 'WRN-000029',
    customerId: 'KH022',
    customerCode: 'C00076',
    customerName: 'Customer C00076',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00076',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-21 11:50',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-21 11:50',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000287',
    code: 'WRN-000287',
    customerId: 'KH074',
    customerCode: 'C00128',
    customerName: 'Customer C00128',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00128',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 12',
    status: 'new',
    createdDate: '2026-05-21 11:44',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-21 11:44',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000471',
    code: 'WRN-000471',
    customerId: 'KH059',
    customerCode: 'C00113',
    customerName: 'Customer C00113',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00113',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 10',
    status: 'in_progress',
    createdDate: '2026-05-21 09:57',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-21 09:57',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000440',
    code: 'WRN-000440',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-21 08:06',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-21 08:06',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000174',
    code: 'WRN-000174',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 19',
    status: 'resolved',
    createdDate: '2026-05-21 07:28',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-21 07:28',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-25 07:28',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000261',
    code: 'WRN-000261',
    customerId: 'KH087',
    customerCode: 'C00141',
    customerName: 'Customer C00141',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00141',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 8',
    status: 'resolved',
    createdDate: '2026-05-21 07:25',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-21 07:25',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-26 07:25',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000467',
    code: 'WRN-000467',
    customerId: 'KH081',
    customerCode: 'C00135',
    customerName: 'Customer C00135',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00135',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-21 03:17',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-21 03:17',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000160',
    code: 'WRN-000160',
    customerId: 'KH059',
    customerCode: 'C00113',
    customerName: 'Customer C00113',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00113',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 11',
    status: 'new',
    createdDate: '2026-05-21 03:01',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-21 03:01',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000158',
    code: 'WRN-000158',
    customerId: 'KH009',
    customerCode: 'C00063',
    customerName: 'Customer C00063',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00063',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-21 00:42',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-21 00:42',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000422',
    code: 'WRN-000422',
    customerId: 'KH094',
    customerCode: 'C00148',
    customerName: 'Customer C00148',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00148',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-20 23:42',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-20 23:42',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000007',
    code: 'WRN-000007',
    customerId: 'KH062',
    customerCode: 'C00116',
    customerName: 'Customer C00116',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00116',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 30',
    status: 'new',
    createdDate: '2026-05-20 21:59',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-20 21:59',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000095',
    code: 'WRN-000095',
    customerId: 'KH050',
    customerCode: 'C00104',
    customerName: 'Customer C00104',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00104',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 7',
    status: 'resolved',
    createdDate: '2026-05-20 19:17',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-20 19:17',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-29 19:17',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000125',
    code: 'WRN-000125',
    customerId: 'KH078',
    customerCode: 'C00132',
    customerName: 'Customer C00132',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00132',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-20 19:00',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-20 19:00',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000485',
    code: 'WRN-000485',
    customerId: 'KH081',
    customerCode: 'C00135',
    customerName: 'Customer C00135',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00135',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 12',
    status: 'new',
    createdDate: '2026-05-20 17:00',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-20 17:00',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000091',
    code: 'WRN-000091',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-20 14:06',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-20 14:06',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000251',
    code: 'WRN-000251',
    customerId: 'KH044',
    customerCode: 'C00098',
    customerName: 'Customer C00098',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00098',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 1',
    status: 'new',
    createdDate: '2026-05-20 12:13',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-20 12:13',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000078',
    code: 'WRN-000078',
    customerId: 'KH070',
    customerCode: 'C00124',
    customerName: 'Customer C00124',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00124',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-20 11:06',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-20 11:06',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000119',
    code: 'WRN-000119',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 20',
    status: 'resolved',
    createdDate: '2026-05-20 07:22',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-20 07:22',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-06-04 07:22',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000260',
    code: 'WRN-000260',
    customerId: 'KH040',
    customerCode: 'C00094',
    customerName: 'Customer C00094',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00094',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 28',
    status: 'resolved',
    createdDate: '2026-05-20 06:20',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-20 06:20',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: '2026-06-01 06:20',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000207',
    code: 'WRN-000207',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 25',
    status: 'in_progress',
    createdDate: '2026-05-20 05:43',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-20 05:43',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000298',
    code: 'WRN-000298',
    customerId: 'KH032',
    customerCode: 'C00086',
    customerName: 'Customer C00086',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00086',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-20 04:44',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-20 04:44',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-25 04:44',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000475',
    code: 'WRN-000475',
    customerId: 'KH016',
    customerCode: 'C00070',
    customerName: 'Customer C00070',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00070',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 2',
    status: 'resolved',
    createdDate: '2026-05-20 01:04',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-20 01:04',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-06-02 01:04',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000101',
    code: 'WRN-000101',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 14',
    status: 'resolved',
    createdDate: '2026-05-19 23:27',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-19 23:27',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-25 23:27',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000170',
    code: 'WRN-000170',
    customerId: 'KH024',
    customerCode: 'C00078',
    customerName: 'Customer C00078',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00078',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 8',
    status: 'in_progress',
    createdDate: '2026-05-19 22:03',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-19 22:03',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000191',
    code: 'WRN-000191',
    customerId: 'KH096',
    customerCode: 'C00150',
    customerName: 'Customer C00150',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00150',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 11',
    status: 'new',
    createdDate: '2026-05-19 21:31',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-19 21:31',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000084',
    code: 'WRN-000084',
    customerId: 'KH092',
    customerCode: 'C00146',
    customerName: 'Customer C00146',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00146',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-19 19:32',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-19 19:32',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000164',
    code: 'WRN-000164',
    customerId: 'KH008',
    customerCode: 'C00062',
    customerName: 'Customer C00062',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00062',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 9',
    status: 'new',
    createdDate: '2026-05-19 19:11',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-19 19:11',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000094',
    code: 'WRN-000094',
    customerId: 'KH081',
    customerCode: 'C00135',
    customerName: 'Customer C00135',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00135',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 8',
    status: 'resolved',
    createdDate: '2026-05-19 15:30',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-19 15:30',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-28 15:30',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000016',
    code: 'WRN-000016',
    customerId: 'KH009',
    customerCode: 'C00063',
    customerName: 'Customer C00063',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00063',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 10',
    status: 'new',
    createdDate: '2026-05-19 14:59',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-19 14:59',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000269',
    code: 'WRN-000269',
    customerId: 'KH006',
    customerCode: 'C00060',
    customerName: 'Customer C00060',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00060',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-05-19 11:30',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-19 11:30',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000044',
    code: 'WRN-000044',
    customerId: 'KH066',
    customerCode: 'C00120',
    customerName: 'Customer C00120',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00120',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 15',
    status: 'new',
    createdDate: '2026-05-19 11:25',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-19 11:25',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000100',
    code: 'WRN-000100',
    customerId: 'KH096',
    customerCode: 'C00150',
    customerName: 'Customer C00150',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00150',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 24',
    status: 'in_progress',
    createdDate: '2026-05-19 10:40',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-19 10:40',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000340',
    code: 'WRN-000340',
    customerId: 'KH054',
    customerCode: 'C00108',
    customerName: 'Customer C00108',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00108',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 30',
    status: 'in_progress',
    createdDate: '2026-05-19 07:52',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-19 07:52',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000477',
    code: 'WRN-000477',
    customerId: 'KH003',
    customerCode: 'C00057',
    customerName: 'Customer C00057',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00057',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 9',
    status: 'new',
    createdDate: '2026-05-19 05:03',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-19 05:03',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000329',
    code: 'WRN-000329',
    customerId: 'KH093',
    customerCode: 'C00147',
    customerName: 'Customer C00147',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00147',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 28',
    status: 'resolved',
    createdDate: '2026-05-19 04:49',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-19 04:49',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-24 04:49',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000040',
    code: 'WRN-000040',
    customerId: 'KH025',
    customerCode: 'C00079',
    customerName: 'Customer C00079',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00079',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 30',
    status: 'resolved',
    createdDate: '2026-05-19 04:29',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-19 04:29',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-21 04:29',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000031',
    code: 'WRN-000031',
    customerId: 'KH065',
    customerCode: 'C00119',
    customerName: 'Customer C00119',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00119',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-19 03:55',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-19 03:55',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-21 03:55',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000006',
    code: 'WRN-000006',
    customerId: 'KH015',
    customerCode: 'C00069',
    customerName: 'Customer C00069',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00069',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 12',
    status: 'in_progress',
    createdDate: '2026-05-19 03:51',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-19 03:51',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000065',
    code: 'WRN-000065',
    customerId: 'KH080',
    customerCode: 'C00134',
    customerName: 'Customer C00134',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00134',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 7',
    status: 'new',
    createdDate: '2026-05-19 03:18',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-19 03:18',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000411',
    code: 'WRN-000411',
    customerId: 'KH018',
    customerCode: 'C00072',
    customerName: 'Customer C00072',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00072',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-19 03:15',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-19 03:15',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000382',
    code: 'WRN-000382',
    customerId: 'KH091',
    customerCode: 'C00145',
    customerName: 'Customer C00145',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00145',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 4',
    status: 'in_progress',
    createdDate: '2026-05-19 00:08',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-19 00:08',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000151',
    code: 'WRN-000151',
    customerId: 'KH024',
    customerCode: 'C00078',
    customerName: 'Customer C00078',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00078',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 10',
    status: 'resolved',
    createdDate: '2026-05-18 22:52',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-18 22:52',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-28 22:52',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000353',
    code: 'WRN-000353',
    customerId: 'KH082',
    customerCode: 'C00136',
    customerName: 'Customer C00136',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-008',
    indicatorName: 'Indicator IND-BEH-008',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00136',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-008 vượt ngưỡng với điểm 6',
    status: 'in_progress',
    createdDate: '2026-05-18 22:08',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-18 22:08',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000449',
    code: 'WRN-000449',
    customerId: 'KH049',
    customerCode: 'C00103',
    customerName: 'Customer C00103',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00103',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-18 21:43',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-18 21:43',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000052',
    code: 'WRN-000052',
    customerId: 'KH083',
    customerCode: 'C00137',
    customerName: 'Customer C00137',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00137',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-18 20:40',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-18 20:40',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000014',
    code: 'WRN-000014',
    customerId: 'KH009',
    customerCode: 'C00063',
    customerName: 'Customer C00063',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00063',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-18 14:40',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-18 14:40',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000362',
    code: 'WRN-000362',
    customerId: 'KH024',
    customerCode: 'C00078',
    customerName: 'Customer C00078',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00078',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-18 14:17',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-18 14:17',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000214',
    code: 'WRN-000214',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 8',
    status: 'resolved',
    createdDate: '2026-05-18 13:44',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-18 13:44',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-31 13:44',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000404',
    code: 'WRN-000404',
    customerId: 'KH001',
    customerCode: 'C00055',
    customerName: 'Customer C00055',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00055',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 26',
    status: 'new',
    createdDate: '2026-05-18 11:45',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-18 11:45',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000306',
    code: 'WRN-000306',
    customerId: 'KH025',
    customerCode: 'C00079',
    customerName: 'Customer C00079',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00079',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-18 10:44',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-18 10:44',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000498',
    code: 'WRN-000498',
    customerId: 'KH056',
    customerCode: 'C00110',
    customerName: 'Customer C00110',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00110',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-18 08:52',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-18 08:52',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000328',
    code: 'WRN-000328',
    customerId: 'KH036',
    customerCode: 'C00090',
    customerName: 'Customer C00090',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00090',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 8',
    status: 'in_progress',
    createdDate: '2026-05-18 02:13',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-18 02:13',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000457',
    code: 'WRN-000457',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 11',
    status: 'new',
    createdDate: '2026-05-18 01:56',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-18 01:56',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000413',
    code: 'WRN-000413',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-18 01:04',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-18 01:04',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000418',
    code: 'WRN-000418',
    customerId: 'KH057',
    customerCode: 'C00111',
    customerName: 'Customer C00111',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00111',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 17',
    status: 'resolved',
    createdDate: '2026-05-17 20:28',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-17 20:28',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-18 20:28',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000395',
    code: 'WRN-000395',
    customerId: 'KH091',
    customerCode: 'C00145',
    customerName: 'Customer C00145',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00145',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 16',
    status: 'in_progress',
    createdDate: '2026-05-17 20:14',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-17 20:14',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000206',
    code: 'WRN-000206',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 1',
    status: 'new',
    createdDate: '2026-05-17 20:10',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-17 20:10',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000047',
    code: 'WRN-000047',
    customerId: 'KH034',
    customerCode: 'C00088',
    customerName: 'Customer C00088',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00088',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 2',
    status: 'resolved',
    createdDate: '2026-05-17 15:55',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-17 15:55',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-29 15:55',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000453',
    code: 'WRN-000453',
    customerId: 'KH091',
    customerCode: 'C00145',
    customerName: 'Customer C00145',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00145',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 14',
    status: 'in_progress',
    createdDate: '2026-05-17 15:18',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-17 15:18',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000003',
    code: 'WRN-000003',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 19',
    status: 'resolved',
    createdDate: '2026-05-17 14:10',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-17 14:10',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-27 14:10',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000391',
    code: 'WRN-000391',
    customerId: 'KH002',
    customerCode: 'C00056',
    customerName: 'Customer C00056',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00056',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 20',
    status: 'resolved',
    createdDate: '2026-05-17 12:33',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-17 12:33',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-20 12:33',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000299',
    code: 'WRN-000299',
    customerId: 'KH086',
    customerCode: 'C00140',
    customerName: 'Customer C00140',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00140',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-17 11:23',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-17 11:23',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000359',
    code: 'WRN-000359',
    customerId: 'KH028',
    customerCode: 'C00082',
    customerName: 'Customer C00082',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00082',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-17 11:03',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-17 11:03',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000465',
    code: 'WRN-000465',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-17 10:13',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-17 10:13',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000059',
    code: 'WRN-000059',
    customerId: 'KH098',
    customerCode: 'C00152',
    customerName: 'Customer C00152',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00152',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 6',
    status: 'resolved',
    createdDate: '2026-05-17 09:22',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-17 09:22',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-23 09:22',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000077',
    code: 'WRN-000077',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 25',
    status: 'in_progress',
    createdDate: '2026-05-17 04:00',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-17 04:00',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000480',
    code: 'WRN-000480',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 28',
    status: 'resolved',
    createdDate: '2026-05-17 02:23',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-17 02:23',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-23 02:23',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000145',
    code: 'WRN-000145',
    customerId: 'KH033',
    customerCode: 'C00087',
    customerName: 'Customer C00087',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00087',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-16 23:17',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-16 23:17',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000431',
    code: 'WRN-000431',
    customerId: 'KH096',
    customerCode: 'C00150',
    customerName: 'Customer C00150',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00150',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-16 22:03',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-16 22:03',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000239',
    code: 'WRN-000239',
    customerId: 'KH071',
    customerCode: 'C00125',
    customerName: 'Customer C00125',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00125',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-16 19:53',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-16 19:53',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000290',
    code: 'WRN-000290',
    customerId: 'KH038',
    customerCode: 'C00092',
    customerName: 'Customer C00092',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00092',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-16 16:32',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-16 16:32',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000371',
    code: 'WRN-000371',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-16 14:57',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-16 14:57',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000403',
    code: 'WRN-000403',
    customerId: 'KH094',
    customerCode: 'C00148',
    customerName: 'Customer C00148',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00148',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 2',
    status: 'in_progress',
    createdDate: '2026-05-16 13:29',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-16 13:29',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000335',
    code: 'WRN-000335',
    customerId: 'KH014',
    customerCode: 'C00068',
    customerName: 'Customer C00068',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00068',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-16 12:05',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-16 12:05',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000156',
    code: 'WRN-000156',
    customerId: 'KH047',
    customerCode: 'C00101',
    customerName: 'Customer C00101',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00101',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 17',
    status: 'in_progress',
    createdDate: '2026-05-16 11:13',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-16 11:13',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000048',
    code: 'WRN-000048',
    customerId: 'KH099',
    customerCode: 'C00153',
    customerName: 'Customer C00153',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00153',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 9',
    status: 'new',
    createdDate: '2026-05-16 10:49',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-16 10:49',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000285',
    code: 'WRN-000285',
    customerId: 'KH052',
    customerCode: 'C00106',
    customerName: 'Customer C00106',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00106',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-16 09:34',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-16 09:34',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000148',
    code: 'WRN-000148',
    customerId: 'KH099',
    customerCode: 'C00153',
    customerName: 'Customer C00153',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00153',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 21',
    status: 'new',
    createdDate: '2026-05-16 08:54',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-16 08:54',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000274',
    code: 'WRN-000274',
    customerId: 'KH084',
    customerCode: 'C00138',
    customerName: 'Customer C00138',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00138',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-16 08:41',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-16 08:41',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000034',
    code: 'WRN-000034',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-16 08:23',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-16 08:23',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000021',
    code: 'WRN-000021',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-16 06:18',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-16 06:18',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000309',
    code: 'WRN-000309',
    customerId: 'KH092',
    customerCode: 'C00146',
    customerName: 'Customer C00146',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00146',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 5',
    status: 'in_progress',
    createdDate: '2026-05-16 06:08',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-16 06:08',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000131',
    code: 'WRN-000131',
    customerId: 'KH048',
    customerCode: 'C00102',
    customerName: 'Customer C00102',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00102',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 10',
    status: 'resolved',
    createdDate: '2026-05-16 05:48',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-16 05:48',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-29 05:48',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000057',
    code: 'WRN-000057',
    customerId: 'KH094',
    customerCode: 'C00148',
    customerName: 'Customer C00148',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00148',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-16 05:23',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-16 05:23',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000076',
    code: 'WRN-000076',
    customerId: 'KH012',
    customerCode: 'C00066',
    customerName: 'Customer C00066',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00066',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 22',
    status: 'resolved',
    createdDate: '2026-05-15 23:54',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-15 23:54',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-30 23:54',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000405',
    code: 'WRN-000405',
    customerId: 'KH055',
    customerCode: 'C00109',
    customerName: 'Customer C00109',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00109',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 5',
    status: 'resolved',
    createdDate: '2026-05-15 23:44',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-15 23:44',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-19 23:44',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000468',
    code: 'WRN-000468',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 16',
    status: 'resolved',
    createdDate: '2026-05-15 23:04',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-15 23:04',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-29 23:04',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000432',
    code: 'WRN-000432',
    customerId: 'KH092',
    customerCode: 'C00146',
    customerName: 'Customer C00146',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00146',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 1',
    status: 'in_progress',
    createdDate: '2026-05-15 22:39',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-15 22:39',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000011',
    code: 'WRN-000011',
    customerId: 'KH039',
    customerCode: 'C00093',
    customerName: 'Customer C00093',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00093',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 25',
    status: 'new',
    createdDate: '2026-05-15 20:27',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-15 20:27',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000041',
    code: 'WRN-000041',
    customerId: 'KH078',
    customerCode: 'C00132',
    customerName: 'Customer C00132',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00132',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-15 20:08',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-15 20:08',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000311',
    code: 'WRN-000311',
    customerId: 'KH040',
    customerCode: 'C00094',
    customerName: 'Customer C00094',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00094',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-15 17:53',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-15 17:53',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000013',
    code: 'WRN-000013',
    customerId: 'KH065',
    customerCode: 'C00119',
    customerName: 'Customer C00119',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00119',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 26',
    status: 'new',
    createdDate: '2026-05-15 17:47',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-15 17:47',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000188',
    code: 'WRN-000188',
    customerId: 'KH068',
    customerCode: 'C00122',
    customerName: 'Customer C00122',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00122',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 29',
    status: 'in_progress',
    createdDate: '2026-05-15 15:44',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-15 15:44',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000093',
    code: 'WRN-000093',
    customerId: 'KH007',
    customerCode: 'C00061',
    customerName: 'Customer C00061',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00061',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-15 15:24',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-15 15:24',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000275',
    code: 'WRN-000275',
    customerId: 'KH027',
    customerCode: 'C00081',
    customerName: 'Customer C00081',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00081',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 21',
    status: 'in_progress',
    createdDate: '2026-05-15 15:04',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-15 15:04',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000234',
    code: 'WRN-000234',
    customerId: 'KH035',
    customerCode: 'C00089',
    customerName: 'Customer C00089',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00089',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 1',
    status: 'in_progress',
    createdDate: '2026-05-15 13:12',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-15 13:12',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000225',
    code: 'WRN-000225',
    customerId: 'KH033',
    customerCode: 'C00087',
    customerName: 'Customer C00087',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00087',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 9',
    status: 'resolved',
    createdDate: '2026-05-15 11:17',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-15 11:17',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-19 11:17',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000212',
    code: 'WRN-000212',
    customerId: 'KH055',
    customerCode: 'C00109',
    customerName: 'Customer C00109',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00109',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 11',
    status: 'in_progress',
    createdDate: '2026-05-15 10:14',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-15 10:14',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000476',
    code: 'WRN-000476',
    customerId: 'KH065',
    customerCode: 'C00119',
    customerName: 'Customer C00119',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00119',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 12',
    status: 'resolved',
    createdDate: '2026-05-15 07:55',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-15 07:55',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-18 07:55',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000108',
    code: 'WRN-000108',
    customerId: 'KH064',
    customerCode: 'C00118',
    customerName: 'Customer C00118',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00118',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 22',
    status: 'in_progress',
    createdDate: '2026-05-15 07:54',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-15 07:54',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000083',
    code: 'WRN-000083',
    customerId: 'KH060',
    customerCode: 'C00114',
    customerName: 'Customer C00114',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00114',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-15 07:15',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-15 07:15',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000344',
    code: 'WRN-000344',
    customerId: 'KH007',
    customerCode: 'C00061',
    customerName: 'Customer C00061',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00061',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 30',
    status: 'new',
    createdDate: '2026-05-15 07:09',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-15 07:09',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000494',
    code: 'WRN-000494',
    customerId: 'KH061',
    customerCode: 'C00115',
    customerName: 'Customer C00115',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00115',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-15 06:24',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-15 06:24',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000226',
    code: 'WRN-000226',
    customerId: 'KH041',
    customerCode: 'C00095',
    customerName: 'Customer C00095',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00095',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 14',
    status: 'in_progress',
    createdDate: '2026-05-15 06:13',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-15 06:13',
    lastCheckedBy: 'System Auto',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000074',
    code: 'WRN-000074',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 17',
    status: 'in_progress',
    createdDate: '2026-05-15 04:24',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-15 04:24',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000080',
    code: 'WRN-000080',
    customerId: 'KH052',
    customerCode: 'C00106',
    customerName: 'Customer C00106',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00106',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-15 03:11',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-15 03:11',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000386',
    code: 'WRN-000386',
    customerId: 'KH040',
    customerCode: 'C00094',
    customerName: 'Customer C00094',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00094',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-15 01:41',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-15 01:41',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000121',
    code: 'WRN-000121',
    customerId: 'KH076',
    customerCode: 'C00130',
    customerName: 'Customer C00130',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00130',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 9',
    status: 'new',
    createdDate: '2026-05-15 00:49',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-15 00:49',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000193',
    code: 'WRN-000193',
    customerId: 'KH027',
    customerCode: 'C00081',
    customerName: 'Customer C00081',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00081',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 27',
    status: 'new',
    createdDate: '2026-05-14 22:55',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-14 22:55',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000106',
    code: 'WRN-000106',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-14 18:36',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-14 18:36',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000474',
    code: 'WRN-000474',
    customerId: 'KH033',
    customerCode: 'C00087',
    customerName: 'Customer C00087',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00087',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 9',
    status: 'in_progress',
    createdDate: '2026-05-14 17:39',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-14 17:39',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000416',
    code: 'WRN-000416',
    customerId: 'KH092',
    customerCode: 'C00146',
    customerName: 'Customer C00146',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00146',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 1',
    status: 'new',
    createdDate: '2026-05-14 16:22',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-14 16:22',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000424',
    code: 'WRN-000424',
    customerId: 'KH011',
    customerCode: 'C00065',
    customerName: 'Customer C00065',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00065',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 19',
    status: 'resolved',
    createdDate: '2026-05-14 12:23',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-14 12:23',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-23 12:23',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000153',
    code: 'WRN-000153',
    customerId: 'KH023',
    customerCode: 'C00077',
    customerName: 'Customer C00077',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00077',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 14',
    status: 'new',
    createdDate: '2026-05-14 12:20',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-14 12:20',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000169',
    code: 'WRN-000169',
    customerId: 'KH037',
    customerCode: 'C00091',
    customerName: 'Customer C00091',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00091',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-14 10:39',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-14 10:39',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000157',
    code: 'WRN-000157',
    customerId: 'KH034',
    customerCode: 'C00088',
    customerName: 'Customer C00088',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00088',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 3',
    status: 'in_progress',
    createdDate: '2026-05-14 10:19',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-14 10:19',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000439',
    code: 'WRN-000439',
    customerId: 'KH064',
    customerCode: 'C00118',
    customerName: 'Customer C00118',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-008',
    indicatorName: 'Indicator IND-BEH-008',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00118',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-008 vượt ngưỡng với điểm 17',
    status: 'resolved',
    createdDate: '2026-05-14 07:12',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-14 07:12',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-24 07:12',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000222',
    code: 'WRN-000222',
    customerId: 'KH016',
    customerCode: 'C00070',
    customerName: 'Customer C00070',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00070',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 29',
    status: 'resolved',
    createdDate: '2026-05-14 07:07',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-14 07:07',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-27 07:07',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000230',
    code: 'WRN-000230',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 26',
    status: 'resolved',
    createdDate: '2026-05-14 05:19',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-14 05:19',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-26 05:19',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000111',
    code: 'WRN-000111',
    customerId: 'KH008',
    customerCode: 'C00062',
    customerName: 'Customer C00062',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00062',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 20',
    status: 'in_progress',
    createdDate: '2026-05-14 04:03',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-14 04:03',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000088',
    code: 'WRN-000088',
    customerId: 'KH075',
    customerCode: 'C00129',
    customerName: 'Customer C00129',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00129',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 18',
    status: 'resolved',
    createdDate: '2026-05-14 04:02',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-14 04:02',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-19 04:02',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000296',
    code: 'WRN-000296',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 20',
    status: 'in_progress',
    createdDate: '2026-05-14 03:22',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-14 03:22',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000241',
    code: 'WRN-000241',
    customerId: 'KH014',
    customerCode: 'C00068',
    customerName: 'Customer C00068',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00068',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 30',
    status: 'new',
    createdDate: '2026-05-14 02:01',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-14 02:01',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000067',
    code: 'WRN-000067',
    customerId: 'KH049',
    customerCode: 'C00103',
    customerName: 'Customer C00103',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00103',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-14 01:16',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-14 01:16',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000045',
    code: 'WRN-000045',
    customerId: 'KH067',
    customerCode: 'C00121',
    customerName: 'Customer C00121',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00121',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 22',
    status: 'new',
    createdDate: '2026-05-13 23:44',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-13 23:44',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000056',
    code: 'WRN-000056',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-13 22:39',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-13 22:39',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000450',
    code: 'WRN-000450',
    customerId: 'KH037',
    customerCode: 'C00091',
    customerName: 'Customer C00091',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00091',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 4',
    status: 'in_progress',
    createdDate: '2026-05-13 22:07',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-13 22:07',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000134',
    code: 'WRN-000134',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-05-13 20:29',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-13 20:29',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000369',
    code: 'WRN-000369',
    customerId: 'KH077',
    customerCode: 'C00131',
    customerName: 'Customer C00131',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00131',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 11',
    status: 'new',
    createdDate: '2026-05-13 18:53',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-13 18:53',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000079',
    code: 'WRN-000079',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 28',
    status: 'in_progress',
    createdDate: '2026-05-13 18:17',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-13 18:17',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000209',
    code: 'WRN-000209',
    customerId: 'KH025',
    customerCode: 'C00079',
    customerName: 'Customer C00079',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00079',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 5',
    status: 'resolved',
    createdDate: '2026-05-13 16:15',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-13 16:15',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-20 16:15',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000357',
    code: 'WRN-000357',
    customerId: 'KH098',
    customerCode: 'C00152',
    customerName: 'Customer C00152',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00152',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-13 16:08',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-13 16:08',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000455',
    code: 'WRN-000455',
    customerId: 'KH044',
    customerCode: 'C00098',
    customerName: 'Customer C00098',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00098',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 7',
    status: 'resolved',
    createdDate: '2026-05-13 13:11',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-13 13:11',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-23 13:11',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000393',
    code: 'WRN-000393',
    customerId: 'KH054',
    customerCode: 'C00108',
    customerName: 'Customer C00108',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-007',
    indicatorName: 'Indicator IND-PAY-007',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00108',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-007 vượt ngưỡng với điểm 5',
    status: 'in_progress',
    createdDate: '2026-05-13 11:56',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-13 11:56',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000365',
    code: 'WRN-000365',
    customerId: 'KH044',
    customerCode: 'C00098',
    customerName: 'Customer C00098',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00098',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 14',
    status: 'resolved',
    createdDate: '2026-05-13 08:30',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-13 08:30',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-28 08:30',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000373',
    code: 'WRN-000373',
    customerId: 'KH091',
    customerCode: 'C00145',
    customerName: 'Customer C00145',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00145',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-13 06:35',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-13 06:35',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000022',
    code: 'WRN-000022',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 12',
    status: 'resolved',
    createdDate: '2026-05-13 05:35',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-13 05:35',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-28 05:35',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000205',
    code: 'WRN-000205',
    customerId: 'KH071',
    customerCode: 'C00125',
    customerName: 'Customer C00125',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00125',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 14',
    status: 'in_progress',
    createdDate: '2026-05-13 04:25',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-13 04:25',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000481',
    code: 'WRN-000481',
    customerId: 'KH056',
    customerCode: 'C00110',
    customerName: 'Customer C00110',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00110',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-13 00:40',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-13 00:40',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000270',
    code: 'WRN-000270',
    customerId: 'KH016',
    customerCode: 'C00070',
    customerName: 'Customer C00070',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00070',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 20',
    status: 'new',
    createdDate: '2026-05-13 00:38',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-13 00:38',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000491',
    code: 'WRN-000491',
    customerId: 'KH086',
    customerCode: 'C00140',
    customerName: 'Customer C00140',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00140',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 27',
    status: 'resolved',
    createdDate: '2026-05-12 23:54',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-12 23:54',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-22 23:54',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000256',
    code: 'WRN-000256',
    customerId: 'KH052',
    customerCode: 'C00106',
    customerName: 'Customer C00106',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00106',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-12 23:40',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-12 23:40',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-18 23:40',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000387',
    code: 'WRN-000387',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-12 21:24',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-12 21:24',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000113',
    code: 'WRN-000113',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-12 17:28',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-12 17:28',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000385',
    code: 'WRN-000385',
    customerId: 'KH083',
    customerCode: 'C00137',
    customerName: 'Customer C00137',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00137',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 9',
    status: 'new',
    createdDate: '2026-05-12 16:52',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-12 16:52',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000327',
    code: 'WRN-000327',
    customerId: 'KH030',
    customerCode: 'C00084',
    customerName: 'Customer C00084',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00084',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 10',
    status: 'resolved',
    createdDate: '2026-05-12 16:23',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-12 16:23',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-16 16:23',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000284',
    code: 'WRN-000284',
    customerId: 'KH064',
    customerCode: 'C00118',
    customerName: 'Customer C00118',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00118',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 12',
    status: 'new',
    createdDate: '2026-05-12 16:11',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-12 16:11',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000493',
    code: 'WRN-000493',
    customerId: 'KH056',
    customerCode: 'C00110',
    customerName: 'Customer C00110',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00110',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 9',
    status: 'in_progress',
    createdDate: '2026-05-12 15:58',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-12 15:58',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000243',
    code: 'WRN-000243',
    customerId: 'KH030',
    customerCode: 'C00084',
    customerName: 'Customer C00084',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00084',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-12 10:33',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-12 10:33',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000499',
    code: 'WRN-000499',
    customerId: 'KH093',
    customerCode: 'C00147',
    customerName: 'Customer C00147',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00147',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 6',
    status: 'in_progress',
    createdDate: '2026-05-12 10:33',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-12 10:33',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000149',
    code: 'WRN-000149',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 28',
    status: 'new',
    createdDate: '2026-05-12 09:25',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-12 09:25',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000278',
    code: 'WRN-000278',
    customerId: 'KH089',
    customerCode: 'C00143',
    customerName: 'Customer C00143',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00143',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-12 06:59',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-12 06:59',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000190',
    code: 'WRN-000190',
    customerId: 'KH003',
    customerCode: 'C00057',
    customerName: 'Customer C00057',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00057',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 10',
    status: 'new',
    createdDate: '2026-05-12 05:58',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-12 05:58',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000434',
    code: 'WRN-000434',
    customerId: 'KH070',
    customerCode: 'C00124',
    customerName: 'Customer C00124',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00124',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 9',
    status: 'new',
    createdDate: '2026-05-12 05:23',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-12 05:23',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000196',
    code: 'WRN-000196',
    customerId: 'KH068',
    customerCode: 'C00122',
    customerName: 'Customer C00122',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00122',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 1',
    status: 'resolved',
    createdDate: '2026-05-12 04:36',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-12 04:36',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: '2026-05-15 04:36',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000026',
    code: 'WRN-000026',
    customerId: 'KH052',
    customerCode: 'C00106',
    customerName: 'Customer C00106',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00106',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 23',
    status: 'resolved',
    createdDate: '2026-05-12 03:17',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-12 03:17',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-27 03:17',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000368',
    code: 'WRN-000368',
    customerId: 'KH081',
    customerCode: 'C00135',
    customerName: 'Customer C00135',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00135',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-12 02:33',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-12 02:33',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000289',
    code: 'WRN-000289',
    customerId: 'KH025',
    customerCode: 'C00079',
    customerName: 'Customer C00079',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00079',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 24',
    status: 'resolved',
    createdDate: '2026-05-12 01:41',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-12 01:41',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-26 01:41',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000281',
    code: 'WRN-000281',
    customerId: 'KH084',
    customerCode: 'C00138',
    customerName: 'Customer C00138',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00138',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-12 01:36',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-12 01:36',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000361',
    code: 'WRN-000361',
    customerId: 'KH074',
    customerCode: 'C00128',
    customerName: 'Customer C00128',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00128',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 1',
    status: 'in_progress',
    createdDate: '2026-05-12 01:02',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-12 01:02',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000399',
    code: 'WRN-000399',
    customerId: 'KH003',
    customerCode: 'C00057',
    customerName: 'Customer C00057',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00057',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-12 00:51',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-12 00:51',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000355',
    code: 'WRN-000355',
    customerId: 'KH077',
    customerCode: 'C00131',
    customerName: 'Customer C00131',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-009',
    indicatorName: 'Indicator IND-EXT-009',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00131',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-009 vượt ngưỡng với điểm 23',
    status: 'new',
    createdDate: '2026-05-12 00:31',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-12 00:31',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000092',
    code: 'WRN-000092',
    customerId: 'KH043',
    customerCode: 'C00097',
    customerName: 'Customer C00097',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00097',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-05-11 21:36',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-11 21:36',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000488',
    code: 'WRN-000488',
    customerId: 'KH016',
    customerCode: 'C00070',
    customerName: 'Customer C00070',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00070',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 10',
    status: 'resolved',
    createdDate: '2026-05-11 18:20',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-11 18:20',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-14 18:20',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000497',
    code: 'WRN-000497',
    customerId: 'KH061',
    customerCode: 'C00115',
    customerName: 'Customer C00115',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00115',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-11 18:16',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-11 18:16',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000415',
    code: 'WRN-000415',
    customerId: 'KH087',
    customerCode: 'C00141',
    customerName: 'Customer C00141',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00141',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 3',
    status: 'new',
    createdDate: '2026-05-11 17:58',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-11 17:58',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000140',
    code: 'WRN-000140',
    customerId: 'KH058',
    customerCode: 'C00112',
    customerName: 'Customer C00112',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00112',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 1',
    status: 'new',
    createdDate: '2026-05-11 17:42',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-11 17:42',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000036',
    code: 'WRN-000036',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 2',
    status: 'in_progress',
    createdDate: '2026-05-11 16:24',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-11 16:24',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000346',
    code: 'WRN-000346',
    customerId: 'KH009',
    customerCode: 'C00063',
    customerName: 'Customer C00063',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00063',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-11 16:08',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-11 16:08',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000236',
    code: 'WRN-000236',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-11 16:04',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-11 16:04',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000073',
    code: 'WRN-000073',
    customerId: 'KH007',
    customerCode: 'C00061',
    customerName: 'Customer C00061',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00061',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 25',
    status: 'new',
    createdDate: '2026-05-11 14:49',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-11 14:49',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000061',
    code: 'WRN-000061',
    customerId: 'KH059',
    customerCode: 'C00113',
    customerName: 'Customer C00113',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00113',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 24',
    status: 'resolved',
    createdDate: '2026-05-11 09:48',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-11 09:48',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-20 09:48',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000167',
    code: 'WRN-000167',
    customerId: 'KH008',
    customerCode: 'C00062',
    customerName: 'Customer C00062',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00062',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 23',
    status: 'resolved',
    createdDate: '2026-05-11 04:53',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-11 04:53',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-18 04:53',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000219',
    code: 'WRN-000219',
    customerId: 'KH078',
    customerCode: 'C00132',
    customerName: 'Customer C00132',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00132',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 10',
    status: 'in_progress',
    createdDate: '2026-05-11 04:49',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-11 04:49',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000180',
    code: 'WRN-000180',
    customerId: 'KH050',
    customerCode: 'C00104',
    customerName: 'Customer C00104',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00104',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 22',
    status: 'new',
    createdDate: '2026-05-11 04:15',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-11 04:15',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000154',
    code: 'WRN-000154',
    customerId: 'KH060',
    customerCode: 'C00114',
    customerName: 'Customer C00114',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00114',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 17',
    status: 'in_progress',
    createdDate: '2026-05-11 02:20',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-11 02:20',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000035',
    code: 'WRN-000035',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 13',
    status: 'resolved',
    createdDate: '2026-05-11 01:11',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-11 01:11',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-15 01:11',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000210',
    code: 'WRN-000210',
    customerId: 'KH086',
    customerCode: 'C00140',
    customerName: 'Customer C00140',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00140',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-11 00:50',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-11 00:50',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000320',
    code: 'WRN-000320',
    customerId: 'KH014',
    customerCode: 'C00068',
    customerName: 'Customer C00068',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00068',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-11 00:09',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-11 00:09',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000264',
    code: 'WRN-000264',
    customerId: 'KH080',
    customerCode: 'C00134',
    customerName: 'Customer C00134',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00134',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-10 22:48',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-10 22:48',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-24 22:48',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000208',
    code: 'WRN-000208',
    customerId: 'KH097',
    customerCode: 'C00151',
    customerName: 'Customer C00151',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00151',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 15',
    status: 'new',
    createdDate: '2026-05-10 22:36',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-10 22:36',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000181',
    code: 'WRN-000181',
    customerId: 'KH081',
    customerCode: 'C00135',
    customerName: 'Customer C00135',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00135',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-10 21:01',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-10 21:01',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000294',
    code: 'WRN-000294',
    customerId: 'KH081',
    customerCode: 'C00135',
    customerName: 'Customer C00135',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00135',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 29',
    status: 'resolved',
    createdDate: '2026-05-10 20:36',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-10 20:36',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-24 20:36',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000238',
    code: 'WRN-000238',
    customerId: 'KH089',
    customerCode: 'C00143',
    customerName: 'Customer C00143',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00143',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 17',
    status: 'resolved',
    createdDate: '2026-05-10 20:14',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-10 20:14',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-20 20:14',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000259',
    code: 'WRN-000259',
    customerId: 'KH077',
    customerCode: 'C00131',
    customerName: 'Customer C00131',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00131',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-10 19:38',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-10 19:38',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000402',
    code: 'WRN-000402',
    customerId: 'KH091',
    customerCode: 'C00145',
    customerName: 'Customer C00145',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00145',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 14',
    status: 'new',
    createdDate: '2026-05-10 18:29',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-10 18:29',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000409',
    code: 'WRN-000409',
    customerId: 'KH018',
    customerCode: 'C00072',
    customerName: 'Customer C00072',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00072',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 29',
    status: 'resolved',
    createdDate: '2026-05-10 17:19',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-10 17:19',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-22 17:19',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000301',
    code: 'WRN-000301',
    customerId: 'KH055',
    customerCode: 'C00109',
    customerName: 'Customer C00109',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00109',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 10',
    status: 'new',
    createdDate: '2026-05-10 17:16',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-10 17:16',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000304',
    code: 'WRN-000304',
    customerId: 'KH090',
    customerCode: 'C00144',
    customerName: 'Customer C00144',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00144',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-10 15:51',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-10 15:51',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000147',
    code: 'WRN-000147',
    customerId: 'KH085',
    customerCode: 'C00139',
    customerName: 'Customer C00139',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00139',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-10 15:39',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-10 15:39',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000460',
    code: 'WRN-000460',
    customerId: 'KH082',
    customerCode: 'C00136',
    customerName: 'Customer C00136',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00136',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 12',
    status: 'in_progress',
    createdDate: '2026-05-10 14:18',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-10 14:18',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000172',
    code: 'WRN-000172',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 22',
    status: 'new',
    createdDate: '2026-05-10 13:16',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-10 13:16',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000319',
    code: 'WRN-000319',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 28',
    status: 'resolved',
    createdDate: '2026-05-10 12:10',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-10 12:10',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-12 12:10',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000221',
    code: 'WRN-000221',
    customerId: 'KH085',
    customerCode: 'C00139',
    customerName: 'Customer C00139',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00139',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-10 11:22',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-10 11:22',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000360',
    code: 'WRN-000360',
    customerId: 'KH059',
    customerCode: 'C00113',
    customerName: 'Customer C00113',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00113',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 26',
    status: 'new',
    createdDate: '2026-05-10 08:48',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-10 08:48',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000099',
    code: 'WRN-000099',
    customerId: 'KH015',
    customerCode: 'C00069',
    customerName: 'Customer C00069',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00069',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 29',
    status: 'resolved',
    createdDate: '2026-05-10 06:53',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-10 06:53',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-18 06:53',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000124',
    code: 'WRN-000124',
    customerId: 'KH097',
    customerCode: 'C00151',
    customerName: 'Customer C00151',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00151',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 7',
    status: 'new',
    createdDate: '2026-05-10 06:35',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-10 06:35',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000070',
    code: 'WRN-000070',
    customerId: 'KH087',
    customerCode: 'C00141',
    customerName: 'Customer C00141',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00141',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 4',
    status: 'resolved',
    createdDate: '2026-05-10 02:55',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-10 02:55',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-22 02:55',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000223',
    code: 'WRN-000223',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 27',
    status: 'in_progress',
    createdDate: '2026-05-10 01:33',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-10 01:33',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000479',
    code: 'WRN-000479',
    customerId: 'KH066',
    customerCode: 'C00120',
    customerName: 'Customer C00120',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00120',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-05-10 00:59',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-10 00:59',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000161',
    code: 'WRN-000161',
    customerId: 'KH002',
    customerCode: 'C00056',
    customerName: 'Customer C00056',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00056',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 10',
    status: 'new',
    createdDate: '2026-05-09 19:36',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-09 19:36',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000419',
    code: 'WRN-000419',
    customerId: 'KH090',
    customerCode: 'C00144',
    customerName: 'Customer C00144',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00144',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 20',
    status: 'new',
    createdDate: '2026-05-09 19:15',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-09 19:15',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000010',
    code: 'WRN-000010',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 17',
    status: 'in_progress',
    createdDate: '2026-05-09 16:19',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-09 16:19',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000183',
    code: 'WRN-000183',
    customerId: 'KH075',
    customerCode: 'C00129',
    customerName: 'Customer C00129',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00129',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 12',
    status: 'new',
    createdDate: '2026-05-09 15:53',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-09 15:53',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000338',
    code: 'WRN-000338',
    customerId: 'KH080',
    customerCode: 'C00134',
    customerName: 'Customer C00134',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00134',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 13',
    status: 'resolved',
    createdDate: '2026-05-09 15:19',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-09 15:19',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-24 15:19',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000377',
    code: 'WRN-000377',
    customerId: 'KH042',
    customerCode: 'C00096',
    customerName: 'Customer C00096',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00096',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 14',
    status: 'in_progress',
    createdDate: '2026-05-09 14:22',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-09 14:22',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000276',
    code: 'WRN-000276',
    customerId: 'KH003',
    customerCode: 'C00057',
    customerName: 'Customer C00057',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00057',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 10',
    status: 'in_progress',
    createdDate: '2026-05-09 12:59',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-09 12:59',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000081',
    code: 'WRN-000081',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-09 12:45',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-09 12:45',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000242',
    code: 'WRN-000242',
    customerId: 'KH037',
    customerCode: 'C00091',
    customerName: 'Customer C00091',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00091',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-09 10:42',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-09 10:42',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000437',
    code: 'WRN-000437',
    customerId: 'KH077',
    customerCode: 'C00131',
    customerName: 'Customer C00131',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00131',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-09 09:35',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-09 09:35',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000233',
    code: 'WRN-000233',
    customerId: 'KH093',
    customerCode: 'C00147',
    customerName: 'Customer C00147',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00147',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-09 06:31',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-09 06:31',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000197',
    code: 'WRN-000197',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-09 05:38',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-09 05:38',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000249',
    code: 'WRN-000249',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 21',
    status: 'in_progress',
    createdDate: '2026-05-09 05:29',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-09 05:29',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000272',
    code: 'WRN-000272',
    customerId: 'KH043',
    customerCode: 'C00097',
    customerName: 'Customer C00097',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00097',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 17',
    status: 'in_progress',
    createdDate: '2026-05-09 05:05',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-09 05:05',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000443',
    code: 'WRN-000443',
    customerId: 'KH097',
    customerCode: 'C00151',
    customerName: 'Customer C00151',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00151',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 10',
    status: 'in_progress',
    createdDate: '2026-05-09 04:01',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-09 04:01',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000435',
    code: 'WRN-000435',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-09 02:20',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-09 02:20',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000325',
    code: 'WRN-000325',
    customerId: 'KH074',
    customerCode: 'C00128',
    customerName: 'Customer C00128',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00128',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 8',
    status: 'in_progress',
    createdDate: '2026-05-09 02:04',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-09 02:04',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000177',
    code: 'WRN-000177',
    customerId: 'KH048',
    customerCode: 'C00102',
    customerName: 'Customer C00102',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00102',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 18',
    status: 'resolved',
    createdDate: '2026-05-08 17:57',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-08 17:57',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-17 17:57',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000118',
    code: 'WRN-000118',
    customerId: 'KH098',
    customerCode: 'C00152',
    customerName: 'Customer C00152',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00152',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 27',
    status: 'in_progress',
    createdDate: '2026-05-08 16:27',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-08 16:27',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000049',
    code: 'WRN-000049',
    customerId: 'KH043',
    customerCode: 'C00097',
    customerName: 'Customer C00097',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00097',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-08 16:08',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-08 16:08',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000133',
    code: 'WRN-000133',
    customerId: 'KH011',
    customerCode: 'C00065',
    customerName: 'Customer C00065',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00065',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-08 16:07',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-08 16:07',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000307',
    code: 'WRN-000307',
    customerId: 'KH096',
    customerCode: 'C00150',
    customerName: 'Customer C00150',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00150',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-08 14:43',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-08 14:43',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000155',
    code: 'WRN-000155',
    customerId: 'KH031',
    customerCode: 'C00085',
    customerName: 'Customer C00085',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00085',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-08 11:49',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-08 11:49',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000379',
    code: 'WRN-000379',
    customerId: 'KH085',
    customerCode: 'C00139',
    customerName: 'Customer C00139',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00139',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 25',
    status: 'in_progress',
    createdDate: '2026-05-08 11:46',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-08 11:46',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000354',
    code: 'WRN-000354',
    customerId: 'KH010',
    customerCode: 'C00064',
    customerName: 'Customer C00064',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00064',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 25',
    status: 'new',
    createdDate: '2026-05-08 11:44',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-08 11:44',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000135',
    code: 'WRN-000135',
    customerId: 'KH045',
    customerCode: 'C00099',
    customerName: 'Customer C00099',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00099',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 1',
    status: 'in_progress',
    createdDate: '2026-05-08 08:53',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-08 08:53',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000072',
    code: 'WRN-000072',
    customerId: 'KH001',
    customerCode: 'C00055',
    customerName: 'Customer C00055',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00055',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-08 08:42',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-08 08:42',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000408',
    code: 'WRN-000408',
    customerId: 'KH082',
    customerCode: 'C00136',
    customerName: 'Customer C00136',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00136',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 26',
    status: 'in_progress',
    createdDate: '2026-05-08 06:27',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-08 06:27',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000231',
    code: 'WRN-000231',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-08 05:18',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-08 05:18',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000254',
    code: 'WRN-000254',
    customerId: 'KH038',
    customerCode: 'C00092',
    customerName: 'Customer C00092',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00092',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-08 04:06',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-08 04:06',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000429',
    code: 'WRN-000429',
    customerId: 'KH031',
    customerCode: 'C00085',
    customerName: 'Customer C00085',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00085',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-08 03:42',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-08 03:42',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000265',
    code: 'WRN-000265',
    customerId: 'KH010',
    customerCode: 'C00064',
    customerName: 'Customer C00064',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00064',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 18',
    status: 'in_progress',
    createdDate: '2026-05-08 03:27',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-08 03:27',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000407',
    code: 'WRN-000407',
    customerId: 'KH050',
    customerCode: 'C00104',
    customerName: 'Customer C00104',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00104',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 30',
    status: 'in_progress',
    createdDate: '2026-05-08 02:55',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-08 02:55',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000176',
    code: 'WRN-000176',
    customerId: 'KH076',
    customerCode: 'C00130',
    customerName: 'Customer C00130',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00130',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-07 23:49',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-07 23:49',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000237',
    code: 'WRN-000237',
    customerId: 'KH049',
    customerCode: 'C00103',
    customerName: 'Customer C00103',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00103',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 29',
    status: 'in_progress',
    createdDate: '2026-05-07 22:32',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-07 22:32',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000075',
    code: 'WRN-000075',
    customerId: 'KH095',
    customerCode: 'C00149',
    customerName: 'Customer C00149',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00149',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 29',
    status: 'resolved',
    createdDate: '2026-05-07 22:00',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-07 22:00',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-12 22:00',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000482',
    code: 'WRN-000482',
    customerId: 'KH036',
    customerCode: 'C00090',
    customerName: 'Customer C00090',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00090',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-07 21:24',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-07 21:24',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000182',
    code: 'WRN-000182',
    customerId: 'KH027',
    customerCode: 'C00081',
    customerName: 'Customer C00081',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00081',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 4',
    status: 'new',
    createdDate: '2026-05-07 18:20',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-07 18:20',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000046',
    code: 'WRN-000046',
    customerId: 'KH085',
    customerCode: 'C00139',
    customerName: 'Customer C00139',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00139',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 23',
    status: 'new',
    createdDate: '2026-05-07 12:17',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-07 12:17',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000150',
    code: 'WRN-000150',
    customerId: 'KH021',
    customerCode: 'C00075',
    customerName: 'Customer C00075',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00075',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-07 10:30',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-07 10:30',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000258',
    code: 'WRN-000258',
    customerId: 'KH042',
    customerCode: 'C00096',
    customerName: 'Customer C00096',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00096',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 18',
    status: 'in_progress',
    createdDate: '2026-05-07 10:27',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-07 10:27',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000401',
    code: 'WRN-000401',
    customerId: 'KH098',
    customerCode: 'C00152',
    customerName: 'Customer C00152',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-008',
    indicatorName: 'Indicator IND-BEH-008',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00152',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-008 vượt ngưỡng với điểm 26',
    status: 'resolved',
    createdDate: '2026-05-07 08:25',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-07 08:25',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-21 08:25',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000473',
    code: 'WRN-000473',
    customerId: 'KH078',
    customerCode: 'C00132',
    customerName: 'Customer C00132',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00132',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-07 07:14',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-07 07:14',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000130',
    code: 'WRN-000130',
    customerId: 'KH053',
    customerCode: 'C00107',
    customerName: 'Customer C00107',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00107',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 28',
    status: 'new',
    createdDate: '2026-05-07 07:01',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-07 07:01',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000216',
    code: 'WRN-000216',
    customerId: 'KH078',
    customerCode: 'C00132',
    customerName: 'Customer C00132',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00132',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 17',
    status: 'resolved',
    createdDate: '2026-05-07 02:06',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-07 02:06',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-14 02:06',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000454',
    code: 'WRN-000454',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-06 23:30',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-06 23:30',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000018',
    code: 'WRN-000018',
    customerId: 'KH030',
    customerCode: 'C00084',
    customerName: 'Customer C00084',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00084',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 18',
    status: 'in_progress',
    createdDate: '2026-05-06 20:50',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-06 20:50',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000310',
    code: 'WRN-000310',
    customerId: 'KH019',
    customerCode: 'C00073',
    customerName: 'Customer C00073',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00073',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 12',
    status: 'new',
    createdDate: '2026-05-06 14:31',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-06 14:31',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000224',
    code: 'WRN-000224',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-06 13:28',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-06 13:28',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000388',
    code: 'WRN-000388',
    customerId: 'KH080',
    customerCode: 'C00134',
    customerName: 'Customer C00134',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-009',
    indicatorName: 'Indicator IND-FIN-009',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00134',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-009 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-06 12:02',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-06 12:02',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000376',
    code: 'WRN-000376',
    customerId: 'KH080',
    customerCode: 'C00134',
    customerName: 'Customer C00134',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 6,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00134',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 6',
    status: 'new',
    createdDate: '2026-05-06 08:31',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-06 08:31',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000500',
    code: 'WRN-000500',
    customerId: 'KH029',
    customerCode: 'C00083',
    customerName: 'Customer C00083',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00083',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 2',
    status: 'in_progress',
    createdDate: '2026-05-06 06:10',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-06 06:10',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000448',
    code: 'WRN-000448',
    customerId: 'KH014',
    customerCode: 'C00068',
    customerName: 'Customer C00068',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00068',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 10',
    status: 'in_progress',
    createdDate: '2026-05-06 05:46',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-06 05:46',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000244',
    code: 'WRN-000244',
    customerId: 'KH018',
    customerCode: 'C00072',
    customerName: 'Customer C00072',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00072',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 20',
    status: 'new',
    createdDate: '2026-05-06 01:23',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-06 01:23',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000394',
    code: 'WRN-000394',
    customerId: 'KH010',
    customerCode: 'C00064',
    customerName: 'Customer C00064',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00064',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 19',
    status: 'new',
    createdDate: '2026-05-05 23:28',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-05 23:28',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000227',
    code: 'WRN-000227',
    customerId: 'KH046',
    customerCode: 'C00100',
    customerName: 'Customer C00100',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00100',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 3',
    status: 'resolved',
    createdDate: '2026-05-05 20:44',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-05 20:44',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-14 20:44',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000096',
    code: 'WRN-000096',
    customerId: 'KH041',
    customerCode: 'C00095',
    customerName: 'Customer C00095',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00095',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 3',
    status: 'new',
    createdDate: '2026-05-05 17:39',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-05 17:39',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000315',
    code: 'WRN-000315',
    customerId: 'KH042',
    customerCode: 'C00096',
    customerName: 'Customer C00096',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-006',
    indicatorName: 'Indicator IND-PAY-006',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00096',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-006 vượt ngưỡng với điểm 11',
    status: 'resolved',
    createdDate: '2026-05-05 17:13',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-05 17:13',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: '2026-05-08 17:13',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000253',
    code: 'WRN-000253',
    customerId: 'KH003',
    customerCode: 'C00057',
    customerName: 'Customer C00057',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00057',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-05 16:40',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-05 16:40',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-19 16:40',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000173',
    code: 'WRN-000173',
    customerId: 'KH021',
    customerCode: 'C00075',
    customerName: 'Customer C00075',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00075',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-05-05 15:08',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-05 15:08',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000324',
    code: 'WRN-000324',
    customerId: 'KH061',
    customerCode: 'C00115',
    customerName: 'Customer C00115',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00115',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 25',
    status: 'new',
    createdDate: '2026-05-05 14:30',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-05 14:30',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000198',
    code: 'WRN-000198',
    customerId: 'KH025',
    customerCode: 'C00079',
    customerName: 'Customer C00079',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00079',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-05 13:25',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-05 13:25',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000489',
    code: 'WRN-000489',
    customerId: 'KH018',
    customerCode: 'C00072',
    customerName: 'Customer C00072',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 30,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00072',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 30',
    status: 'in_progress',
    createdDate: '2026-05-05 13:23',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-05 13:23',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000317',
    code: 'WRN-000317',
    customerId: 'KH027',
    customerCode: 'C00081',
    customerName: 'Customer C00081',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-008',
    indicatorName: 'Indicator IND-FIN-008',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00081',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-008 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-05 13:21',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-05 13:21',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000487',
    code: 'WRN-000487',
    customerId: 'KH044',
    customerCode: 'C00098',
    customerName: 'Customer C00098',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00098',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 23',
    status: 'resolved',
    createdDate: '2026-05-05 13:05',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-05 13:05',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: '2026-05-12 13:05',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000380',
    code: 'WRN-000380',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-002',
    indicatorName: 'Indicator IND-EXT-002',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-002 vượt ngưỡng với điểm 14',
    status: 'in_progress',
    createdDate: '2026-05-05 11:46',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-05 11:46',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Nguyễn Văn A',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000366',
    code: 'WRN-000366',
    customerId: 'KH021',
    customerCode: 'C00075',
    customerName: 'Customer C00075',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00075',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 27',
    status: 'new',
    createdDate: '2026-05-05 10:45',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-05 10:45',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000332',
    code: 'WRN-000332',
    customerId: 'KH061',
    customerCode: 'C00115',
    customerName: 'Customer C00115',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00115',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 27',
    status: 'resolved',
    createdDate: '2026-05-05 09:29',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-05 09:29',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-13 09:29',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000426',
    code: 'WRN-000426',
    customerId: 'KH077',
    customerCode: 'C00131',
    customerName: 'Customer C00131',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00131',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 27',
    status: 'new',
    createdDate: '2026-05-05 08:53',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-05 08:53',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000137',
    code: 'WRN-000137',
    customerId: 'KH099',
    customerCode: 'C00153',
    customerName: 'Customer C00153',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00153',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 3',
    status: 'new',
    createdDate: '2026-05-05 08:38',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-05 08:38',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000087',
    code: 'WRN-000087',
    customerId: 'KH067',
    customerCode: 'C00121',
    customerName: 'Customer C00121',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-003',
    indicatorName: 'Indicator IND-EXT-003',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00121',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-003 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-05 04:38',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-05 04:38',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000252',
    code: 'WRN-000252',
    customerId: 'KH002',
    customerCode: 'C00056',
    customerName: 'Customer C00056',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00056',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 25',
    status: 'resolved',
    createdDate: '2026-05-05 04:31',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-05 04:31',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: '2026-05-20 04:31',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000102',
    code: 'WRN-000102',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 11',
    status: 'in_progress',
    createdDate: '2026-05-05 00:31',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-05 00:31',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000283',
    code: 'WRN-000283',
    customerId: 'KH036',
    customerCode: 'C00090',
    customerName: 'Customer C00090',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00090',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 17',
    status: 'resolved',
    createdDate: '2026-05-04 23:40',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-04 23:40',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-19 23:40',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000097',
    code: 'WRN-000097',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 21',
    status: 'in_progress',
    createdDate: '2026-05-04 18:50',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-04 18:50',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000104',
    code: 'WRN-000104',
    customerId: 'KH005',
    customerCode: 'C00059',
    customerName: 'Customer C00059',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00059',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 22',
    status: 'in_progress',
    createdDate: '2026-05-04 18:30',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-04 18:30',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000350',
    code: 'WRN-000350',
    customerId: 'KH097',
    customerCode: 'C00151',
    customerName: 'Customer C00151',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-003',
    indicatorName: 'Indicator IND-FIN-003',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00151',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-003 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-04 18:26',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-04 18:26',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000142',
    code: 'WRN-000142',
    customerId: 'KH081',
    customerCode: 'C00135',
    customerName: 'Customer C00135',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00135',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-04 15:03',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-04 15:03',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000060',
    code: 'WRN-000060',
    customerId: 'KH089',
    customerCode: 'C00143',
    customerName: 'Customer C00143',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00143',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 10',
    status: 'in_progress',
    createdDate: '2026-05-04 14:47',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-04 14:47',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000277',
    code: 'WRN-000277',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-04 13:55',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-04 13:55',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000490',
    code: 'WRN-000490',
    customerId: 'KH080',
    customerCode: 'C00134',
    customerName: 'Customer C00134',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00134',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 25',
    status: 'resolved',
    createdDate: '2026-05-04 12:52',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-04 12:52',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-07 12:52',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000189',
    code: 'WRN-000189',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 7,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 7',
    status: 'in_progress',
    createdDate: '2026-05-04 10:48',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-04 10:48',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000027',
    code: 'WRN-000027',
    customerId: 'KH090',
    customerCode: 'C00144',
    customerName: 'Customer C00144',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-LOAN-001',
    modelName: 'Model MDL-LOAN-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00144',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 21',
    status: 'in_progress',
    createdDate: '2026-05-04 10:25',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-04 10:25',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000105',
    code: 'WRN-000105',
    customerId: 'KH078',
    customerCode: 'C00132',
    customerName: 'Customer C00132',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00132',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-05-04 09:30',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-04 09:30',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000163',
    code: 'WRN-000163',
    customerId: 'KH076',
    customerCode: 'C00130',
    customerName: 'Customer C00130',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00130',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-04 06:16',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-04 06:16',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000397',
    code: 'WRN-000397',
    customerId: 'KH008',
    customerCode: 'C00062',
    customerName: 'Customer C00062',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00062',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 1',
    status: 'new',
    createdDate: '2026-05-04 06:15',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-04 06:15',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000043',
    code: 'WRN-000043',
    customerId: 'KH034',
    customerCode: 'C00088',
    customerName: 'Customer C00088',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00088',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 29',
    status: 'resolved',
    createdDate: '2026-05-04 04:17',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-04 04:17',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-06 04:17',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000001',
    code: 'WRN-000001',
    customerId: 'KH055',
    customerCode: 'C00109',
    customerName: 'Customer C00109',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00109',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 16',
    status: 'resolved',
    createdDate: '2026-05-03 22:27',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-03 22:27',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: '2026-05-08 22:27',
    resolvedBy: 'Lê Văn C',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000146',
    code: 'WRN-000146',
    customerId: 'KH004',
    customerCode: 'C00058',
    customerName: 'Customer C00058',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00058',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 21',
    status: 'resolved',
    createdDate: '2026-05-03 20:04',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-03 20:04',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: '2026-05-16 20:04',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000293',
    code: 'WRN-000293',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 26',
    status: 'new',
    createdDate: '2026-05-03 19:00',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-03 19:00',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000141',
    code: 'WRN-000141',
    customerId: 'KH044',
    customerCode: 'C00098',
    customerName: 'Customer C00098',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-AUTO-001',
    modelName: 'Model MDL-AUTO-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00098',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 3',
    status: 'resolved',
    createdDate: '2026-05-03 16:09',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-03 16:09',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-04 16:09',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000334',
    code: 'WRN-000334',
    customerId: 'KH079',
    customerCode: 'C00133',
    customerName: 'Customer C00133',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00133',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 4',
    status: 'in_progress',
    createdDate: '2026-05-03 10:18',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-03 10:18',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000384',
    code: 'WRN-000384',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 3',
    status: 'in_progress',
    createdDate: '2026-05-03 10:02',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-03 10:02',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000246',
    code: 'WRN-000246',
    customerId: 'KH089',
    customerCode: 'C00143',
    customerName: 'Customer C00143',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 5,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00143',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 5',
    status: 'new',
    createdDate: '2026-05-03 08:28',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-03 08:28',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000375',
    code: 'WRN-000375',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 2',
    status: 'in_progress',
    createdDate: '2026-05-03 07:36',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-03 07:36',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000005',
    code: 'WRN-000005',
    customerId: 'KH029',
    customerCode: 'C00083',
    customerName: 'Customer C00083',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-002',
    indicatorName: 'Indicator IND-FIN-002',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00083',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-002 vượt ngưỡng với điểm 28',
    status: 'new',
    createdDate: '2026-05-03 04:12',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-03 04:12',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000063',
    code: 'WRN-000063',
    customerId: 'KH020',
    customerCode: 'C00074',
    customerName: 'Customer C00074',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-008',
    indicatorName: 'Indicator IND-PAY-008',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00074',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-008 vượt ngưỡng với điểm 26',
    status: 'in_progress',
    createdDate: '2026-05-03 00:20',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-03 00:20',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000107',
    code: 'WRN-000107',
    customerId: 'KH048',
    customerCode: 'C00102',
    customerName: 'Customer C00102',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-007',
    indicatorName: 'Indicator IND-BEH-007',
    modelId: 'MDL-EXPORT-001',
    modelName: 'Model MDL-EXPORT-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00102',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-007 vượt ngưỡng với điểm 9',
    status: 'resolved',
    createdDate: '2026-05-02 23:35',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-02 23:35',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-04 23:35',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000203',
    code: 'WRN-000203',
    customerId: 'KH054',
    customerCode: 'C00108',
    customerName: 'Customer C00108',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-007',
    indicatorName: 'Indicator IND-PAY-007',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 1,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00108',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-007 vượt ngưỡng với điểm 1',
    status: 'new',
    createdDate: '2026-05-02 22:32',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-02 22:32',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000162',
    code: 'WRN-000162',
    customerId: 'KH086',
    customerCode: 'C00140',
    customerName: 'Customer C00140',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00140',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-05-02 22:13',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-02 22:13',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000255',
    code: 'WRN-000255',
    customerId: 'KH061',
    customerCode: 'C00115',
    customerName: 'Customer C00115',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-007',
    indicatorName: 'Indicator IND-PAY-007',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00115',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-007 vượt ngưỡng với điểm 3',
    status: 'resolved',
    createdDate: '2026-05-02 16:52',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-02 16:52',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-07 16:52',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000496',
    code: 'WRN-000496',
    customerId: 'KH062',
    customerCode: 'C00116',
    customerName: 'Customer C00116',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00116',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-02 15:29',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-02 15:29',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000123',
    code: 'WRN-000123',
    customerId: 'KH026',
    customerCode: 'C00080',
    customerName: 'Customer C00080',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-011',
    indicatorName: 'Indicator IND-EXT-011',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 20,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00080',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-011 vượt ngưỡng với điểm 20',
    status: 'in_progress',
    createdDate: '2026-05-02 14:50',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-02 14:50',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000390',
    code: 'WRN-000390',
    customerId: 'KH021',
    customerCode: 'C00075',
    customerName: 'Customer C00075',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00075',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 12',
    status: 'in_progress',
    createdDate: '2026-05-02 13:53',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-02 13:53',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000166',
    code: 'WRN-000166',
    customerId: 'KH062',
    customerCode: 'C00116',
    customerName: 'Customer C00116',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-003',
    indicatorName: 'Indicator IND-BEH-003',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00116',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-003 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-05-02 11:41',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-02 11:41',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000171',
    code: 'WRN-000171',
    customerId: 'KH010',
    customerCode: 'C00064',
    customerName: 'Customer C00064',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00064',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 22',
    status: 'new',
    createdDate: '2026-05-02 10:40',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-02 10:40',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000381',
    code: 'WRN-000381',
    customerId: 'KH034',
    customerCode: 'C00088',
    customerName: 'Customer C00088',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00088',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 18',
    status: 'new',
    createdDate: '2026-05-02 10:07',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-02 10:07',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000459',
    code: 'WRN-000459',
    customerId: 'KH024',
    customerCode: 'C00078',
    customerName: 'Customer C00078',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00078',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 19',
    status: 'resolved',
    createdDate: '2026-05-02 07:01',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-02 07:01',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-14 07:01',
    resolvedBy: 'Nguyễn Văn A',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000400',
    code: 'WRN-000400',
    customerId: 'KH030',
    customerCode: 'C00084',
    customerName: 'Customer C00084',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00084',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 3',
    status: 'in_progress',
    createdDate: '2026-05-02 06:25',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-02 06:25',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000184',
    code: 'WRN-000184',
    customerId: 'KH032',
    customerCode: 'C00086',
    customerName: 'Customer C00086',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 29,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00086',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 29',
    status: 'new',
    createdDate: '2026-05-02 05:58',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-02 05:58',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000351',
    code: 'WRN-000351',
    customerId: 'KH021',
    customerCode: 'C00075',
    customerName: 'Customer C00075',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00075',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-02 05:07',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-02 05:07',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-16 05:07',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000438',
    code: 'WRN-000438',
    customerId: 'KH049',
    customerCode: 'C00103',
    customerName: 'Customer C00103',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-AGRI-001',
    modelName: 'Model MDL-AGRI-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00103',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 14',
    status: 'new',
    createdDate: '2026-05-02 04:57',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-02 04:57',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000267',
    code: 'WRN-000267',
    customerId: 'KH008',
    customerCode: 'C00062',
    customerName: 'Customer C00062',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-009',
    indicatorName: 'Indicator IND-PAY-009',
    modelId: 'MDL-FINTECH-001',
    modelName: 'Model MDL-FINTECH-001',
    score: 26,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00062',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-009 vượt ngưỡng với điểm 26',
    status: 'in_progress',
    createdDate: '2026-05-02 02:45',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-02 02:45',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000257',
    code: 'WRN-000257',
    customerId: 'KH087',
    customerCode: 'C00141',
    customerName: 'Customer C00141',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 16,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00141',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 16',
    status: 'new',
    createdDate: '2026-05-01 22:43',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-01 22:43',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000331',
    code: 'WRN-000331',
    customerId: 'KH001',
    customerCode: 'C00055',
    customerName: 'Customer C00055',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 19,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00055',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 19',
    status: 'in_progress',
    createdDate: '2026-05-01 21:28',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-05-01 21:28',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000495',
    code: 'WRN-000495',
    customerId: 'KH053',
    customerCode: 'C00107',
    customerName: 'Customer C00107',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-008',
    indicatorName: 'Indicator IND-FIN-008',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00107',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-008 vượt ngưỡng với điểm 13',
    status: 'in_progress',
    createdDate: '2026-05-01 20:05',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-01 20:05',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000302',
    code: 'WRN-000302',
    customerId: 'KH054',
    customerCode: 'C00108',
    customerName: 'Customer C00108',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-005',
    indicatorName: 'Indicator IND-PAY-005',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 11,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00108',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-005 vượt ngưỡng với điểm 11',
    status: 'new',
    createdDate: '2026-05-01 19:38',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-01 19:38',
    lastCheckedBy: 'System Auto',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000103',
    code: 'WRN-000103',
    customerId: 'KH053',
    customerCode: 'C00107',
    customerName: 'Customer C00107',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-008',
    indicatorName: 'Indicator IND-BEH-008',
    modelId: 'MDL-TRADE-001',
    modelName: 'Model MDL-TRADE-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00107',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-008 vượt ngưỡng với điểm 22',
    status: 'resolved',
    createdDate: '2026-05-01 17:50',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-01 17:50',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: '2026-05-14 17:50',
    resolvedBy: 'Hoàng Văn E',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000139',
    code: 'WRN-000139',
    customerId: 'KH032',
    customerCode: 'C00086',
    customerName: 'Customer C00086',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-002',
    indicatorName: 'Indicator IND-BEH-002',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00086',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-002 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-05-01 16:40',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-01 16:40',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000114',
    code: 'WRN-000114',
    customerId: 'KH075',
    customerCode: 'C00129',
    customerName: 'Customer C00129',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00129',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 21',
    status: 'in_progress',
    createdDate: '2026-05-01 15:17',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-01 15:17',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000089',
    code: 'WRN-000089',
    customerId: 'KH053',
    customerCode: 'C00107',
    customerName: 'Customer C00107',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-007',
    indicatorName: 'Indicator IND-FIN-007',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 12,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00107',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-007 vượt ngưỡng với điểm 12',
    status: 'resolved',
    createdDate: '2026-05-01 14:36',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-01 14:36',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-02 14:36',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000165',
    code: 'WRN-000165',
    customerId: 'KH072',
    customerCode: 'C00126',
    customerName: 'Customer C00126',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-008',
    indicatorName: 'Indicator IND-EXT-008',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00126',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-008 vượt ngưỡng với điểm 24',
    status: 'resolved',
    createdDate: '2026-05-01 10:38',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-01 10:38',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: '2026-05-16 10:38',
    resolvedBy: 'System Auto',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000352',
    code: 'WRN-000352',
    customerId: 'KH038',
    customerCode: 'C00092',
    customerName: 'Customer C00092',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 23,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00092',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 23',
    status: 'in_progress',
    createdDate: '2026-05-01 09:40',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-01 09:40',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'Trần Thị B',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000398',
    code: 'WRN-000398',
    customerId: 'KH034',
    customerCode: 'C00088',
    customerName: 'Customer C00088',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00088',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 14',
    status: 'new',
    createdDate: '2026-05-01 06:28',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-05-01 06:28',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000008',
    code: 'WRN-000008',
    customerId: 'KH090',
    customerCode: 'C00144',
    customerName: 'Customer C00144',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-004',
    indicatorName: 'Indicator IND-PAY-004',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 18,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00144',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-004 vượt ngưỡng với điểm 18',
    status: 'in_progress',
    createdDate: '2026-05-01 05:34',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-05-01 05:34',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000068',
    code: 'WRN-000068',
    customerId: 'KH029',
    customerCode: 'C00083',
    customerName: 'Customer C00083',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-008',
    indicatorName: 'Indicator IND-FIN-008',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 27,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00083',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-008 vượt ngưỡng với điểm 27',
    status: 'new',
    createdDate: '2026-05-01 03:36',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-01 03:36',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000028',
    code: 'WRN-000028',
    customerId: 'KH087',
    customerCode: 'C00141',
    customerName: 'Customer C00141',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-003',
    indicatorName: 'Indicator IND-PAY-003',
    modelId: 'MDL-TEST-001',
    modelName: 'Model MDL-TEST-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00141',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-003 vượt ngưỡng với điểm 9',
    status: 'in_progress',
    createdDate: '2026-05-01 03:15',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-05-01 03:15',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: 'Hoàng Văn E',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000179',
    code: 'WRN-000179',
    customerId: 'KH086',
    customerCode: 'C00140',
    customerName: 'Customer C00140',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-FIN-001',
    indicatorName: 'Indicator IND-FIN-001',
    modelId: 'MDL-HOME-001',
    modelName: 'Model MDL-HOME-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00140',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-001 vượt ngưỡng với điểm 10',
    status: 'new',
    createdDate: '2026-05-01 02:57',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-05-01 02:57',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000466',
    code: 'WRN-000466',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-010',
    indicatorName: 'Indicator IND-FIN-010',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-010 vượt ngưỡng với điểm 17',
    status: 'new',
    createdDate: '2026-05-01 02:07',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-05-01 02:07',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000082',
    code: 'WRN-000082',
    customerId: 'KH075',
    customerCode: 'C00129',
    customerName: 'Customer C00129',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-WEALTH-001',
    modelName: 'Model MDL-WEALTH-001',
    score: 8,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00129',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 8',
    status: 'new',
    createdDate: '2026-05-01 01:59',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-01 01:59',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000420',
    code: 'WRN-000420',
    customerId: 'KH031',
    customerCode: 'C00085',
    customerName: 'Customer C00085',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-004',
    indicatorName: 'Indicator IND-BEH-004',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00085',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-004 vượt ngưỡng với điểm 15',
    status: 'resolved',
    createdDate: '2026-05-01 01:00',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-05-01 01:00',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: '2026-05-08 01:00',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000268',
    code: 'WRN-000268',
    customerId: 'KH089',
    customerCode: 'C00143',
    customerName: 'Customer C00143',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-010',
    indicatorName: 'Indicator IND-EXT-010',
    modelId: 'MDL-NPL-001',
    modelName: 'Model MDL-NPL-001',
    score: 24,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00143',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-010 vượt ngưỡng với điểm 24',
    status: 'new',
    createdDate: '2026-04-30 21:42',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-04-30 21:42',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000348',
    code: 'WRN-000348',
    customerId: 'KH053',
    customerCode: 'C00107',
    customerName: 'Customer C00107',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-001',
    indicatorName: 'Indicator IND-BEH-001',
    modelId: 'MDL-VIP-001',
    modelName: 'Model MDL-VIP-001',
    score: 22,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00107',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-001 vượt ngưỡng với điểm 22',
    status: 'new',
    createdDate: '2026-04-30 21:34',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-04-30 21:34',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000266',
    code: 'WRN-000266',
    customerId: 'KH053',
    customerCode: 'C00107',
    customerName: 'Customer C00107',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-HYBRID-001',
    modelName: 'Model MDL-HYBRID-001',
    score: 14,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00107',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 14',
    status: 'in_progress',
    createdDate: '2026-04-30 17:21',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-04-30 17:21',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: 'System Auto',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000185',
    code: 'WRN-000185',
    customerId: 'KH094',
    customerCode: 'C00148',
    customerName: 'Customer C00148',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-BEH-006',
    indicatorName: 'Indicator IND-BEH-006',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 4,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00148',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-006 vượt ngưỡng với điểm 4',
    status: 'resolved',
    createdDate: '2026-04-30 15:09',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-04-30 15:09',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-09 15:09',
    resolvedBy: 'Trần Thị B',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000314',
    code: 'WRN-000314',
    customerId: 'KH019',
    customerCode: 'C00073',
    customerName: 'Customer C00073',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00073',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 17',
    status: 'in_progress',
    createdDate: '2026-04-30 15:09',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-04-30 15:09',
    lastCheckedBy: 'Lê Văn C',
    assignedTo: 'Võ Thị F',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000316',
    code: 'WRN-000316',
    customerId: 'KH028',
    customerCode: 'C00082',
    customerName: 'Customer C00082',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-004',
    indicatorName: 'Indicator IND-FIN-004',
    modelId: 'MDL-RECOVERY-001',
    modelName: 'Model MDL-RECOVERY-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00082',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-004 vượt ngưỡng với điểm 10',
    status: 'resolved',
    createdDate: '2026-04-30 14:40',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-04-30 14:40',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: '2026-05-10 14:40',
    resolvedBy: 'Võ Thị F',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000444',
    code: 'WRN-000444',
    customerId: 'KH017',
    customerCode: 'C00071',
    customerName: 'Customer C00071',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-005',
    indicatorName: 'Indicator IND-EXT-005',
    modelId: 'MDL-STARTUP-001',
    modelName: 'Model MDL-STARTUP-001',
    score: 25,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00071',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-005 vượt ngưỡng với điểm 25',
    status: 'new',
    createdDate: '2026-04-30 13:45',
    createdBy: 'Lê Văn C',
    lastCheckedDate: '2026-04-30 13:45',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000321',
    code: 'WRN-000321',
    customerId: 'KH097',
    customerCode: 'C00151',
    customerName: 'Customer C00151',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-PAY-010',
    indicatorName: 'Indicator IND-PAY-010',
    modelId: 'MDL-SME-001',
    modelName: 'Model MDL-SME-001',
    score: 28,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00151',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-010 vượt ngưỡng với điểm 28',
    status: 'new',
    createdDate: '2026-04-30 12:59',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-04-30 12:59',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000451',
    code: 'WRN-000451',
    customerId: 'KH019',
    customerCode: 'C00073',
    customerName: 'Customer C00073',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-005',
    indicatorName: 'Indicator IND-BEH-005',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00073',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-005 vượt ngưỡng với điểm 15',
    status: 'in_progress',
    createdDate: '2026-04-30 12:08',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-04-30 12:08',
    lastCheckedBy: 'System Auto',
    assignedTo: 'Lê Văn C',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000128',
    code: 'WRN-000128',
    customerId: 'KH051',
    customerCode: 'C00105',
    customerName: 'Customer C00105',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-006',
    indicatorName: 'Indicator IND-FIN-006',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 15,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00105',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-006 vượt ngưỡng với điểm 15',
    status: 'new',
    createdDate: '2026-04-30 10:45',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-04-30 10:45',
    lastCheckedBy: 'Phạm Thị D',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000012',
    code: 'WRN-000012',
    customerId: 'KH029',
    customerCode: 'C00083',
    customerName: 'Customer C00083',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-004',
    indicatorName: 'Indicator IND-EXT-004',
    modelId: 'MDL-RET-003',
    modelName: 'Model MDL-RET-003',
    score: 21,
    maxScore: 30,
    riskLevel: 'high',
    riskLevelVN: 'Cao',
    threshold: 4,
    alertType: 'Cảnh báo Cao',
    message: 'Cảnh báo cao cho khách hàng C00083',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-004 vượt ngưỡng với điểm 21',
    status: 'new',
    createdDate: '2026-04-30 09:10',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-04-30 09:10',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000017',
    code: 'WRN-000017',
    customerId: 'KH048',
    customerCode: 'C00102',
    customerName: 'Customer C00102',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-006',
    indicatorName: 'Indicator IND-EXT-006',
    modelId: 'MDL-CORP-002',
    modelName: 'Model MDL-CORP-002',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00102',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-006 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-04-30 08:18',
    createdBy: 'System Auto',
    lastCheckedDate: '2026-04-30 08:18',
    lastCheckedBy: 'Trần Thị B',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000138',
    code: 'WRN-000138',
    customerId: 'KH073',
    customerCode: 'C00127',
    customerName: 'Customer C00127',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 9,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00127',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 9',
    status: 'new',
    createdDate: '2026-04-30 07:27',
    createdBy: 'Hoàng Văn E',
    lastCheckedDate: '2026-04-30 07:27',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000002',
    code: 'WRN-000002',
    customerId: 'KH013',
    customerCode: 'C00067',
    customerName: 'Customer C00067',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-001',
    indicatorName: 'Indicator IND-PAY-001',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 13,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00067',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-001 vượt ngưỡng với điểm 13',
    status: 'new',
    createdDate: '2026-04-30 06:52',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-04-30 06:52',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000378',
    code: 'WRN-000378',
    customerId: 'KH075',
    customerCode: 'C00129',
    customerName: 'Customer C00129',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-PAY-002',
    indicatorName: 'Indicator IND-PAY-002',
    modelId: 'MDL-RET-001',
    modelName: 'Model MDL-RET-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00129',
    details: 'Chi tiết cảnh báo: Chỉ số IND-PAY-002 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-04-30 06:39',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-04-30 06:39',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000442',
    code: 'WRN-000442',
    customerId: 'KH052',
    customerCode: 'C00106',
    customerName: 'Customer C00106',
    customerType: 'Khách hàng doanh nghiệp',
    indicatorId: 'IND-EXT-001',
    indicatorName: 'Indicator IND-EXT-001',
    modelId: 'MDL-CARD-001',
    modelName: 'Model MDL-CARD-001',
    score: 10,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00106',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-001 vượt ngưỡng với điểm 10',
    status: 'new',
    createdDate: '2026-04-30 04:01',
    createdBy: 'Nguyễn Văn A',
    lastCheckedDate: '2026-04-30 04:01',
    lastCheckedBy: 'Nguyễn Văn A',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  },
  {
    id: 'WRN-000168',
    code: 'WRN-000168',
    customerId: 'KH034',
    customerCode: 'C00088',
    customerName: 'Customer C00088',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-EXT-007',
    indicatorName: 'Indicator IND-EXT-007',
    modelId: 'MDL-CORP-001',
    modelName: 'Model MDL-CORP-001',
    score: 17,
    maxScore: 30,
    riskLevel: 'medium',
    riskLevelVN: 'Trung bình',
    threshold: 2,
    alertType: 'Cảnh báo Trung bình',
    message: 'Cảnh báo trung bình cho khách hàng C00088',
    details: 'Chi tiết cảnh báo: Chỉ số IND-EXT-007 vượt ngưỡng với điểm 17',
    status: 'resolved',
    createdDate: '2026-04-30 03:56',
    createdBy: 'Võ Thị F',
    lastCheckedDate: '2026-04-30 03:56',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: '2026-05-14 03:56',
    resolvedBy: 'Phạm Thị D',
    notes: 'Đã xử lý và theo dõi',
    indicators: [],
  },
  {
    id: 'WRN-000152',
    code: 'WRN-000152',
    customerId: 'KH088',
    customerCode: 'C00142',
    customerName: 'Customer C00142',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-BEH-009',
    indicatorName: 'Indicator IND-BEH-009',
    modelId: 'MDL-OD-001',
    modelName: 'Model MDL-OD-001',
    score: 3,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00142',
    details: 'Chi tiết cảnh báo: Chỉ số IND-BEH-009 vượt ngưỡng với điểm 3',
    status: 'in_progress',
    createdDate: '2026-04-30 03:53',
    createdBy: 'Trần Thị B',
    lastCheckedDate: '2026-04-30 03:53',
    lastCheckedBy: 'Hoàng Văn E',
    assignedTo: 'Phạm Thị D',
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Đang xử lý',
    indicators: [],
  },
  {
    id: 'WRN-000427',
    code: 'WRN-000427',
    customerId: 'KH042',
    customerCode: 'C00096',
    customerName: 'Customer C00096',
    customerType: 'Khách hàng cá nhân',
    indicatorId: 'IND-FIN-005',
    indicatorName: 'Indicator IND-FIN-005',
    modelId: 'MDL-MICRO-001',
    modelName: 'Model MDL-MICRO-001',
    score: 2,
    maxScore: 30,
    riskLevel: 'low',
    riskLevelVN: 'Thấp',
    threshold: 1,
    alertType: 'Cảnh báo Thấp',
    message: 'Cảnh báo thấp cho khách hàng C00096',
    details: 'Chi tiết cảnh báo: Chỉ số IND-FIN-005 vượt ngưỡng với điểm 2',
    status: 'new',
    createdDate: '2026-04-30 02:51',
    createdBy: 'Phạm Thị D',
    lastCheckedDate: '2026-04-30 02:51',
    lastCheckedBy: 'Võ Thị F',
    assignedTo: null,
    resolvedDate: null,
    resolvedBy: null,
    notes: 'Mới phát sinh',
    indicators: [],
  }
];
